<template>
  <div class="page-wrap">
    <img class="d-none" :src="$media_url + currentProfile.photo_path" alt=""
         @click="lightboxItems.push($media_url+currentProfile.photo_path); index=0"/>
    <div class="page-head" v-if="!profile">
      <div class="breadcrumbs">
        <div class="h1">
          <router-link class="link-not-like" to="/workers/">{{ $vuetify.lang.t('$vuetify.menu.workers') }}
          </router-link>
        </div>
        <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.27539 13.7068L7.48229 7.49989L1.27539 1.29299" stroke="#2C1521" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div class="h1">
          {{ currentProfile.name }} {{ currentProfile.lastname }}
        </div>
      </div>
    </div>

    <v-form class="profile p-profile" ref="form" @submit.prevent="">
      <div class="profile-main cards__single">
        <div class="profile-main__left">
          <div class="flex">
            <div class="profile-main__avatar cp">
              <img class="cp" v-if="currentProfile.photo_path" :src="$media_url + currentProfile.photo_path" alt=""
                   @click="lightboxItems.push($media_url+currentProfile.photo_path); index=0"/>
              <img class="cp" v-else :src="$media_url + 'users/noavatar.png'" alt="photo"/>
            </div>
            <v-file-input class="file-input--hide" v-model="photo" accept=".jpg, .png, .jpeg"
                          :placeholder="$vuetify.lang.t('$vuetify.downloadPhoto')" id="photo"></v-file-input>
            <div v-if="editing" class="link" @click="clickInput">
              <span v-if="photo">{{ photo.name }}</span>
              <span v-else>{{ $vuetify.lang.t('$vuetify.changePhoto') }}</span>
            </div>
          </div>

          <div v-if="editing" class="form__row align-baseline" style="flex-wrap: wrap; overflow: hidden">
            <span class="clothes__title">{{ $vuetify.lang.t('$vuetify.signature') }}</span>
            <v-file-input class="file-input--hide" v-model="signature" accept=".jpg, .png, .jpeg"
                          :placeholder="$vuetify.lang.t('$vuetify.addSignature')" id="signature"></v-file-input>
            <button class="btn btn-secondary" style="margin-bottom: 10px; flex: 1" @click="clickSignInput">
                  <span v-if="signature || currentProfile.sign_path">{{
                      $vuetify.lang.t('$vuetify.changeSignature')
                    }}</span>
              <span v-else>{{ $vuetify.lang.t('$vuetify.addSignature') }}</span>
            </button>
            <span v-if="signature">{{ signature.name }}</span>
          </div>


        </div>

        <div class="profile-main__right">
          <div class="profile-main__name h2" v-if="!editing">
            {{ currentProfile.name }} {{ currentProfile.lastname }}
          </div>
          <div class="profile-main__name" v-else>
            <v-text-field v-model="currentProfile.name" :label="$vuetify.lang.t('$vuetify.name')" outlined
                          :rules="[$rules.required]"></v-text-field>
            <v-text-field v-model="currentProfile.lastname" :label="$vuetify.lang.t('$vuetify.surname')" outlined
                          :rules="[$rules.required]"></v-text-field>
          </div>
          <div class="profile-main__post" v-if="!editing">
            <template v-if="currentProfile.position && currentProfile.position.name">
              {{
                currentProfile.position.name[$vuetify.lang.current] ? currentProfile.position.name[$vuetify.lang.current] : currentProfile.position.name['eng'] ? currentProfile.position.name['eng'] : currentProfile.position.name['fin']
              }}
              <svg width="9" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                      d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                      stroke="#333" fill="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </g>
              </svg>
            </template>
            <template v-if="currentProfile.organizations && currentProfile.organizations.length">
              {{ $vuetify.lang.t('$vuetify.profile.works_at') }}
              <span
                  v-for="(org, i) in currentProfile.organizations" :key="org.id"
              >
                <router-link
                    :to="{name: 'CompanyProfile', params: {'id' : org.id}}">
                  {{ org.name }}</router-link><template v-if="i<currentProfile.organizations.length-1">, </template>
              </span>
            </template>
          </div>
          <div class="profile-main__post" v-if="editing">
            <v-select
                v-model="currentProfile.position"
                :items="positions"
                outlined attach
                item-text="name"
                item-value="id"
                return-object
                :placeholder="$vuetify.lang.t('$vuetify.signup.selectSpec')"
                :menu-props="{
            bottom: true,
            offsetY: true,
            maxHeight: 200,
            contentClass: 'select-menu',
          }">
              <template v-slot:selection="{ item }">
                {{
                  item.name[$vuetify.lang.current] ? item.name[$vuetify.lang.current] : item.name['eng'] ? item.name['eng'] : item.name['fin']
                }}
              </template>
              <template v-slot:item="{ item }">
                {{
                  item.name[$vuetify.lang.current] ? item.name[$vuetify.lang.current] : item.name['eng'] ? item.name['eng'] : item.name['fin']
                }}
              </template>
            </v-select>
            <div class="sign-up__buttons btn-group">
              <button class="btn btn-secondary" @click="editing = false">
                {{ $vuetify.lang.t('$vuetify.cancel') }}
              </button>
              <button class="btn btn-primary" @click="edit_cards">
                {{ $vuetify.lang.t('$vuetify.save') }}
              </button>
            </div>
          </div>

          <div class="flex" v-if="!editing">
            <button
                v-if="(permissions.edit.indexOf('Работники') !== -1 && organizations.indexOf(company) !== -1) || profile"
                class="editing-btn btn btn-primary mt-3 btn-ico"
                @click="editing = !editing; loadGroups()">
            <span>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M15.8934 3.38037C16.5059 2.769 17.3317 2.41924 18.1969 2.40476C19.0622 2.39029 19.8993 2.71224 20.5318 3.30278C21.1644 3.89333 21.543 4.70635 21.5879 5.57054C21.6328 6.43474 21.3405 7.28263 20.7726 7.93557L20.6166 8.10357L9.08941 19.6308C8.8437 19.8761 8.5477 20.0653 8.22181 20.1852L8.02381 20.2488L3.15781 21.576C3.06355 21.6019 2.96438 21.6045 2.86891 21.5834C2.77345 21.5623 2.68458 21.5182 2.61006 21.4549C2.53553 21.3916 2.4776 21.311 2.44131 21.2203C2.40502 21.1295 2.39146 21.0312 2.40181 20.934L2.42101 20.838L3.74821 15.9732C3.83941 15.6372 4.00261 15.3252 4.22581 15.0612L4.36621 14.9076L15.8934 3.38037ZM14.8614 6.11037L5.21461 15.756C5.10439 15.8664 5.01676 15.9972 4.95661 16.1412L4.90621 16.2888L3.85381 20.1408L7.70821 19.0908C7.80861 19.0634 7.90502 19.023 7.99501 18.9708L8.12341 18.8844L8.24101 18.7824L17.8866 9.13437L14.8614 6.11037ZM19.7682 4.22877C19.3908 3.85113 18.8859 3.6282 18.3526 3.60378C17.8193 3.57936 17.2961 3.7552 16.8858 4.09677L16.7418 4.22877L15.7098 5.26077L18.7338 8.28717L19.7682 7.25517C20.1459 6.8778 20.3688 6.37289 20.3932 5.83957C20.4176 5.30626 20.2418 4.78308 19.9002 4.37277L19.7682 4.22877Z"
                  fill="#ADB2B7"/>
            </svg>
              </span>
              <span>
            {{ $vuetify.lang.t('$vuetify.edit') }}

            </span>
            </button>
            <button v-else-if="permissions.edit.indexOf('HR') !== -1 && organizations.indexOf(company) === -1"
                    class="btn btn-secondary mt-3 btn-ico" @click="openRespond">
              <span>
                <svg width="0" height="24" viewBox="0 0 0 24" fill="none" xmlns="http://www.w3.org/2000/svg"></svg>
              </span>
              <span>{{ $vuetify.lang.t('$vuetify.cvs.invite') }}</span>
            </button>
          </div>
        </div>

      </div>
      <div class="profile-tabs cards__single" v-if="profile || organizations.indexOf(company) !== -1">
        <div class="profile-tabs__head">
          <div class="profile-tabs__item" :class="{ selected: tab_selected === 1 }" @click="tab_selected = 1">
            {{ $vuetify.lang.t('$vuetify.aboutEmployee') }}
          </div>
          <div class="profile-tabs__item" :class="{ selected: tab_selected === 2 }" @click="tab_selected = 2">
            {{ $vuetify.lang.t('$vuetify.cards') }}
          </div>
          <div class="profile-tabs__item" :class="{ selected: tab_selected === 3 }" @click="tab_selected = 3">
            {{ $vuetify.lang.t('$vuetify.skills') }}
          </div>
          <div class="profile-tabs__item" :class="{ selected: tab_selected === 4 }" @click="tab_selected = 4">
            {{ $vuetify.lang.t('$vuetify.menu.objects') }}
          </div>
          <div class="profile-tabs__item" :class="{ selected: tab_selected === 6 }" @click="tab_selected = 6">
            {{ $vuetify.lang.t('$vuetify.documents') }}
          </div>
        </div>
        <div class="profile-tabs__content ">
          <div v-if="tab_selected === 1" class="profile-tabs__content-item profile-tabs__content-main-info">

            <div class="characteristics" v-if="!editing">

              <div class="characteristics__list characteristics__first">
                <div class="profile-main__options" v-if="!editing">
                  <div class="profile-main__option">
                    <div class="profile-main__option-icon">
                      <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M5.6 17.6005C5.41435 17.6005 5.2363 17.6743 5.10503 17.8056C4.97375 17.9368 4.9 18.1149 4.9 18.3005C4.9 18.4862 4.97375 18.6642 5.10503 18.7955C5.2363 18.9268 5.41435 19.0005 5.6 19.0005H8.4C8.58565 19.0005 8.7637 18.9268 8.89497 18.7955C9.02625 18.6642 9.1 18.4862 9.1 18.3005C9.1 18.1149 9.02625 17.9368 8.89497 17.8056C8.7637 17.6743 8.58565 17.6005 8.4 17.6005H5.6Z"
                            fill="#557EAE"/>
                        <path
                            d="M2.8 0.800537C2.05739 0.800537 1.3452 1.09554 0.820101 1.62064C0.294999 2.14574 0 2.85793 0 3.60054V20.4005C0 21.1431 0.294999 21.8553 0.820101 22.3804C1.3452 22.9055 2.05739 23.2005 2.8 23.2005H11.2C11.9426 23.2005 12.6548 22.9055 13.1799 22.3804C13.705 21.8553 14 21.1431 14 20.4005V3.60054C14 2.85793 13.705 2.14574 13.1799 1.62064C12.6548 1.09554 11.9426 0.800537 11.2 0.800537H2.8ZM1.4 3.60054C1.4 3.22923 1.5475 2.87314 1.81005 2.61059C2.0726 2.34804 2.4287 2.20054 2.8 2.20054H11.2C11.5713 2.20054 11.9274 2.34804 12.1899 2.61059C12.4525 2.87314 12.6 3.22923 12.6 3.60054V20.4005C12.6 20.7718 12.4525 21.1279 12.1899 21.3905C11.9274 21.653 11.5713 21.8005 11.2 21.8005H2.8C2.4287 21.8005 2.0726 21.653 1.81005 21.3905C1.5475 21.1279 1.4 20.7718 1.4 20.4005V3.60054Z"
                            fill="#557EAE"/>
                      </svg>
                    </div>
                    <div class="profile-main__option-title">{{ $vuetify.lang.t('$vuetify.phone') }}</div>

                    <div class="profile-main__option-val" v-if="currentProfile.phone">
                      <a :href="'tel:' + currentProfile.phone.replace(/\D/g, '')">{{ currentProfile.phone }} </a>
                    </div>
                  </div>
                  <div class="profile-main__option">
                    <div class="profile-main__option-icon">
                      <svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M19.7008 0.599854C20.629 0.599854 21.5193 0.968602 22.1757 1.62498C22.832 2.28136 23.2008 3.1716 23.2008 4.09985V15.2999C23.2008 16.2281 22.832 17.1184 22.1757 17.7747C21.5193 18.4311 20.629 18.7999 19.7008 18.7999H4.30078C3.37252 18.7999 2.48228 18.4311 1.82591 17.7747C1.16953 17.1184 0.800781 16.2281 0.800781 15.2999V4.09985C0.800781 3.1716 1.16953 2.28136 1.82591 1.62498C2.48228 0.968602 3.37252 0.599854 4.30078 0.599854H19.7008ZM21.8008 6.14525L12.3564 11.7033C12.2671 11.7557 12.1673 11.7876 12.0642 11.7968C11.961 11.806 11.8571 11.7922 11.76 11.7565L11.6452 11.7033L2.20078 6.14805V15.2999C2.20078 15.8568 2.42203 16.391 2.81586 16.7848C3.20968 17.1786 3.74383 17.3999 4.30078 17.3999H19.7008C20.2577 17.3999 20.7919 17.1786 21.1857 16.7848C21.5795 16.391 21.8008 15.8568 21.8008 15.2999V6.14525ZM19.7008 1.99985H4.30078C3.74383 1.99985 3.20968 2.2211 2.81586 2.61493C2.42203 3.00876 2.20078 3.5429 2.20078 4.09985V4.52265L12.0008 10.2879L21.8008 4.51985V4.09985C21.8008 3.5429 21.5795 3.00876 21.1857 2.61493C20.7919 2.2211 20.2577 1.99985 19.7008 1.99985Z"
                            fill="#557EAE"/>
                      </svg>
                    </div>
                    <div class="profile-main__option-title">email</div>

                    <div class="profile-main__option-val">
                      <a :href="'mailto:' + currentProfile.auth_user_id.email">{{
                          currentProfile.auth_user_id.email
                        }}</a>
                    </div>
                  </div>
                  <div class="profile-main__option">
                    <div class="profile-main__option-icon">
                      <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M5.50059 7.80054C5.31493 7.80054 5.13689 7.87429 5.00561 8.00556C4.87434 8.13684 4.80059 8.31489 4.80059 8.50054C4.80059 8.68619 4.87434 8.86424 5.00561 8.99551C5.13689 9.12679 5.31493 9.20054 5.50059 9.20054H12.5006C12.6862 9.20054 12.8643 9.12679 12.9956 8.99551C13.1268 8.86424 13.2006 8.68619 13.2006 8.50054C13.2006 8.31489 13.1268 8.13684 12.9956 8.00556C12.8643 7.87429 12.6862 7.80054 12.5006 7.80054H5.50059ZM4.80059 12.7005C4.80059 12.5149 4.87434 12.3368 5.00561 12.2056C5.13689 12.0743 5.31493 12.0005 5.50059 12.0005H12.0386C11.8846 12.4387 11.8006 12.9105 11.8006 13.4005H5.50059C5.31493 13.4005 5.13689 13.3268 5.00561 13.1955C4.87434 13.0642 4.80059 12.8862 4.80059 12.7005ZM16.0006 4.30054V9.20054C16.4906 9.20054 16.9624 9.28454 17.4006 9.43994V4.30054C17.4006 3.74358 17.1793 3.20944 16.7855 2.81561C16.3917 2.42179 15.8575 2.20054 15.3006 2.20054H14.6006V1.50054C14.6006 1.31489 14.5268 1.13684 14.3956 1.00556C14.2643 0.874287 14.0862 0.800537 13.9006 0.800537C13.7149 0.800537 13.5369 0.874287 13.4056 1.00556C13.2743 1.13684 13.2006 1.31489 13.2006 1.50054V2.20054H9.70059V1.50054C9.70059 1.31489 9.62684 1.13684 9.49556 1.00556C9.36429 0.874287 9.18624 0.800537 9.00059 0.800537C8.81493 0.800537 8.63689 0.874287 8.50561 1.00556C8.37434 1.13684 8.30059 1.31489 8.30059 1.50054V2.20054H4.80059V1.50054C4.80059 1.31489 4.72684 1.13684 4.59556 1.00556C4.46429 0.874287 4.28624 0.800537 4.10059 0.800537C3.91493 0.800537 3.73689 0.874287 3.60561 1.00556C3.47434 1.13684 3.40059 1.31489 3.40059 1.50054V2.20054H2.70059C2.14363 2.20054 1.60949 2.42179 1.21566 2.81561C0.821835 3.20944 0.600586 3.74358 0.600586 4.30054V21.1005C0.600586 21.6575 0.821835 22.1916 1.21566 22.5855C1.60949 22.9793 2.14363 23.2005 2.70059 23.2005H10.0506C9.75247 22.7681 9.51462 22.2971 9.34359 21.8005H2.70059C2.51493 21.8005 2.33689 21.7268 2.20561 21.5955C2.07434 21.4642 2.00059 21.2862 2.00059 21.1005V4.30054C2.00059 4.11489 2.07434 3.93684 2.20561 3.80556C2.33689 3.67429 2.51493 3.60054 2.70059 3.60054H15.3006C15.4862 3.60054 15.6643 3.67429 15.7956 3.80556C15.9268 3.93684 16.0006 4.11489 16.0006 4.30054ZM5.50059 16.2005C5.31493 16.2005 5.13689 16.2743 5.00561 16.4056C4.87434 16.5368 4.80059 16.7149 4.80059 16.9005C4.80059 17.0862 4.87434 17.2642 5.00561 17.3955C5.13689 17.5268 5.31493 17.6005 5.50059 17.6005H8.30059C8.48624 17.6005 8.66429 17.5268 8.79556 17.3955C8.92684 17.2642 9.00059 17.0862 9.00059 16.9005C9.00059 16.7149 8.92684 16.5368 8.79556 16.4056C8.66429 16.2743 8.48624 16.2005 8.30059 16.2005H5.50059ZM18.8006 13.4005C18.8126 13.0256 18.7492 12.652 18.6141 12.3021C18.4789 11.9521 18.2749 11.6328 18.014 11.3633C17.753 11.0937 17.4406 10.8793 17.0952 10.7329C16.7499 10.5864 16.3786 10.5108 16.0034 10.5106C15.6283 10.5104 15.2569 10.5856 14.9114 10.7318C14.5659 10.8779 14.2532 11.092 13.9921 11.3613C13.7309 11.6306 13.5265 11.9496 13.391 12.2994C13.2555 12.6493 13.1917 13.0228 13.2034 13.3977C13.226 14.1247 13.5306 14.8143 14.0527 15.3206C14.5747 15.8269 15.2734 16.1103 16.0006 16.1106C16.7279 16.111 17.4268 15.8284 17.9494 15.3225C18.472 14.8167 18.7772 14.1274 18.8006 13.4005ZM10.4006 19.7005C10.4006 19.9413 10.4146 20.1751 10.4454 20.4005C10.5836 21.5669 11.1775 22.6313 12.0974 23.3615C13.1348 24.1945 14.5264 24.6005 16.0006 24.6005C17.4748 24.6005 18.8664 24.1945 19.9038 23.3615C20.9566 22.5145 21.6006 21.2629 21.6006 19.7005C21.6006 19.1436 21.3793 18.6094 20.9855 18.2156C20.5917 17.8218 20.0575 17.6005 19.5006 17.6005H12.5006C11.9436 17.6005 11.4095 17.8218 11.0157 18.2156C10.6218 18.6094 10.4006 19.1436 10.4006 19.7005Z"
                            fill="#557EAE"/>
                      </svg>
                    </div>
                    <div class="profile-main__option-title">Veronumero</div>

                    <div class="profile-main__option-val">
                      {{ currentProfile.tax_number }}
                    </div>
                  </div>
                  <div class="profile-main__option">
                    <div class="profile-main__option-icon">
                      <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M9.99922 0.800537C8.51401 0.800537 7.08962 1.39054 6.03942 2.44074C4.98922 3.49094 4.39922 4.91533 4.39922 6.40054C4.39922 7.88575 4.98922 9.31013 6.03942 10.3603C7.08962 11.4105 8.51401 12.0005 9.99922 12.0005C11.4844 12.0005 12.9088 11.4105 13.959 10.3603C15.0092 9.31013 15.5992 7.88575 15.5992 6.40054C15.5992 4.91533 15.0092 3.49094 13.959 2.44074C12.9088 1.39054 11.4844 0.800537 9.99922 0.800537ZM5.79922 6.40054C5.79922 5.28663 6.24172 4.21834 7.02937 3.43069C7.81702 2.64304 8.88531 2.20054 9.99922 2.20054C11.1131 2.20054 12.1814 2.64304 12.9691 3.43069C13.7567 4.21834 14.1992 5.28663 14.1992 6.40054C14.1992 7.51445 13.7567 8.58273 12.9691 9.37039C12.1814 10.158 11.1131 10.6005 9.99922 10.6005C8.88531 10.6005 7.81702 10.158 7.02937 9.37039C6.24172 8.58273 5.79922 7.51445 5.79922 6.40054Z"
                            fill="#557EAE"/>
                        <path
                            d="M3.01182 13.4005C2.64311 13.3991 2.27774 13.4704 1.93665 13.6104C1.59557 13.7505 1.28548 13.9565 1.02418 14.2166C0.762878 14.4767 0.555497 14.7859 0.413932 15.1263C0.272366 15.4668 0.1994 15.8318 0.199219 16.2005C0.199219 18.5679 1.36542 20.3529 3.18822 21.5163C4.98302 22.6601 7.40222 23.2005 9.99922 23.2005C12.5962 23.2005 15.0154 22.6601 16.8102 21.5163C18.633 20.3543 19.7992 18.5665 19.7992 16.2005C19.7992 15.4579 19.5042 14.7457 18.9791 14.2206C18.454 13.6955 17.7418 13.4005 16.9992 13.4005H3.01182ZM1.59922 16.2005C1.59922 15.4263 2.22642 14.8005 3.01182 14.8005H16.9992C17.3705 14.8005 17.7266 14.948 17.9892 15.2106C18.2517 15.4731 18.3992 15.8292 18.3992 16.2005C18.3992 18.0331 17.5284 19.3981 16.057 20.3347C14.559 21.2909 12.4282 21.8005 9.99922 21.8005C7.57022 21.8005 5.43942 21.2909 3.94142 20.3347C2.47142 19.3967 1.59922 18.0345 1.59922 16.2005Z"
                            fill="#557EAE"/>
                      </svg>
                    </div>
                    <div class="profile-main__option-title">Henkilötunnus</div>

                    <div class="profile-main__option-val">
                      {{ currentProfile.social_code_fin }}
                    </div>
                  </div>
                  <div class="profile-main__option">
                    <div class="profile-main__option-icon">
                      <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M10.0001 6.22438C10.3096 6.22438 10.6064 6.10144 10.8252 5.8826C11.044 5.66377 11.167 5.36696 11.167 5.05748C11.167 4.748 11.044 4.45119 10.8252 4.23236C10.6064 4.01352 10.3096 3.89058 10.0001 3.89058C9.69059 3.89058 9.39379 4.01352 9.17495 4.23236C8.95611 4.45119 8.83317 4.748 8.83317 5.05748C8.83317 5.36696 8.95611 5.66377 9.17495 5.8826C9.39379 6.10144 9.69059 6.22438 10.0001 6.22438Z"
                            fill="#557EAE"/>
                        <path
                            d="M18.4001 9.19938H18.5303C19.7805 9.19938 20.2943 7.59358 19.2723 6.86978L11.0809 1.05698C10.7653 0.832977 10.3878 0.712646 10.0008 0.712646C9.61374 0.712646 9.23629 0.832977 8.92067 1.05698L0.727869 6.86978C-0.289931 7.59358 0.219669 9.19938 1.46987 9.19938H1.60007V16.6754C0.758669 17.2158 0.200069 18.1594 0.200069 19.2332V21.0994C0.200069 21.285 0.273819 21.4631 0.405095 21.5944C0.53637 21.7256 0.714418 21.7994 0.900069 21.7994H19.1001C19.2857 21.7994 19.4638 21.7256 19.5951 21.5944C19.7263 21.4631 19.8001 21.285 19.8001 21.0994V19.2332C19.8001 18.1594 19.2429 17.2158 18.4001 16.6768V9.19938ZM9.73127 2.19938C9.81005 2.14356 9.90422 2.11359 10.0008 2.11359C10.0973 2.11359 10.1915 2.14356 10.2703 2.19938L18.1649 7.79938H1.83667L9.73127 2.19938ZM17.0001 9.19938V16.2078C16.9227 16.202 16.8452 16.1992 16.7677 16.1994H14.2001V9.19938H17.0001ZM3.00007 16.2078V9.19938H5.80007V16.1994H3.23387C3.15586 16.1992 3.07787 16.202 3.00007 16.2078ZM3.23387 17.5994H16.7677C17.6693 17.5994 18.4001 18.3302 18.4001 19.2332V20.3994H1.60007V19.2332C1.60007 18.3302 2.33227 17.5994 3.23387 17.5994ZM9.30007 16.1994H7.20007V9.19938H9.30007V16.1994ZM10.7001 16.1994V9.19938H12.8001V16.1994H10.7001Z"
                            fill="#557EAE"/>
                      </svg>
                    </div>
                    <div class="profile-main__option-title">
                      {{ $vuetify.lang.t('$vuetify.bankAccount') }}
                    </div>

                    <div class="profile-main__option-val">
                      {{ currentProfile.bank_account }}
                    </div>
                  </div>
                </div>

                <div class="characteristics__item" v-if="profile">
                  <div class="characteristics__title">{{ $vuetify.lang.t('$vuetify.signature') }}</div>
                  <div class="characteristics__sign" v-if="this.currentProfile.sign_path">
                    <img class="characteristics__sign__content"
                         :src="this.$media_url + this.currentProfile.sign_path" alt="sign">
                  </div>
                  <div class="characteristics__sign_no" v-if="!this.currentProfile.sign_path">
                    {{ $vuetify.lang.t('$vuetify.no') }}
                  </div>
                </div>
              </div>
              <div class="characteristics__list">

                <div class="characteristics__item">
                  <div class="characteristics__title">{{ $vuetify.lang.t('$vuetify.citizenship') }}</div>
                  <div class="characteristics__val">
                    {{ currentProfile.citizenship }}
                  </div>
                </div>

                <div class="characteristics__item">
                  <div class="characteristics__title">{{ $vuetify.lang.t('$vuetify.birthday') }}</div>
                  <div class="characteristics__val">
                    {{ new Date(currentProfile.birthdate).toLocaleDateString(options_date) }}
                  </div>
                </div>

                <div class="characteristics__item" v-if="currentProfile.address_own.street">
                  <div class="characteristics__title">
                    {{ $vuetify.lang.t('$vuetify.addressOwn') }}
                  </div>
                  <div class="characteristics__val">
                    <a target="_blank"
                       :href="'https://www.google.com/maps/search/?api=1&query='+currentProfile.address_own.street + '+' + currentProfile.address_own.house + '+' + currentProfile.address_own.city">
                      {{ currentProfile.address_own.street }} {{ currentProfile.address_own.house }}
                      {{ currentProfile.address_own.entrance ? currentProfile.address_own.entrance + ' ' : '' }}
                      {{ currentProfile.address_own.flat }}, {{ currentProfile.address_own.index }}
                      {{ currentProfile.address_own.city }}, {{ currentProfile.address_own.country }}
                    </a>
                  </div>
                </div>

                <div class="characteristics__item">
                  <div class="characteristics__title">
                    {{ $vuetify.lang.t('$vuetify.addressFin') }}

                  </div>
                  <div class="characteristics__val">
                    <a target="_blank"
                       :href="'https://www.google.com/maps/search/?api=1&query='+currentProfile.address_fin.street + '+' +currentProfile.address_fin.house + '+' + currentProfile.address_fin.city">
                      {{ currentProfile.address_fin.street }} {{ currentProfile.address_fin.house }}
                      {{ currentProfile.address_fin.entrance ? currentProfile.address_fin.entrance + ' ' : '' }}
                      {{ currentProfile.address_fin.flat }}, {{ currentProfile.address_fin.index }}
                      {{ currentProfile.address_fin.city }}
                    </a>
                  </div>
                </div>

                <div class="characteristics__item" v-if="currentProfile.phone_fin">
                  <div class="characteristics__title">
                    {{ $vuetify.lang.t('$vuetify.otherPhone') }}
                  </div>
                  <div class="characteristics__val">
                    {{ currentProfile.phone_fin }}
                  </div>
                </div>
              </div>

              <div class="characteristics__list">
                <div class="characteristics__item"
                     v-if="currentProfile.auto_category && currentProfile.auto_category.length>0">
                  <div class="characteristics__title">{{ $vuetify.lang.t('$vuetify.driverLicense') }}</div>
                  <div class="characteristics__val">
                    <span v-for="item in currentProfile.auto_category" :key="item">{{ item }} </span>
                  </div>
                </div>
                <div class="characteristics__item">
                  <div class="characteristics__title">{{ $vuetify.lang.t('$vuetify.ownCar') }}</div>
                  <div class="characteristics__val">
                    {{ currentProfile.auto ? $vuetify.lang.t('$vuetify.have') : $vuetify.lang.t('$vuetify.no') }}
                  </div>
                </div>
                <div class="characteristics__item">
                  <div class="characteristics__title">{{ $vuetify.lang.t('$vuetify.ownTools') }}</div>
                  <div class="characteristics__val">
                    {{ currentProfile.tool ? $vuetify.lang.t('$vuetify.have') : $vuetify.lang.t('$vuetify.no') }}
                  </div>
                </div>
                <div class="characteristics__item">
                  <div class="characteristics__title">{{ $vuetify.lang.t('$vuetify.languages') }}</div>
                  <div class="characteristics__val">
                    {{
                      (currentProfile.english ? "English 🇬🇧\n" : "")
                    }}
                    <br v-if="currentProfile.english">
                    {{ (currentProfile.estonian ? "Estonian 🇪🇪 " : "") }}
                    <br v-if="currentProfile.estonian">

                    {{

                      (currentProfile.finnish ? "Finnish 🇫🇮 " : "")
                    }}
                    <br v-if="currentProfile.finnish">

                    {{
                      (currentProfile.russian ? "Russian 🇷🇺" : "")
                    }}
                    <br v-if="currentProfile.other_language">

                    {{
                      currentProfile.other_language
                    }}
                  </div>
                </div>
              </div>
              <div class="characteristics__list">
                <div class="characteristics__uniform">
                  <div class="characteristics__uniform-item">
                    <div class="characteristics__uniform-img">
                      <svg width="40" height="44" viewBox="0 0 40 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M13.75 1.16699L1.25 7.41699L1.60758 11.8867M13.75 1.16699H26.25M13.75 1.16699C13.75 2.8246 14.4085 4.41431 15.5806 5.58641C16.7527 6.75851 18.3424 7.41699 20 7.41699M13.75 1.16699L12.3864 8.93214L20 7.41699M26.25 1.16699L38.75 7.41699L38.3924 11.8867M26.25 1.16699C26.25 2.8246 25.5915 4.41431 24.4194 5.58641C23.2473 6.75851 21.6576 7.41699 20 7.41699M26.25 1.16699L27.7273 8.93214L20 7.41699M30.4167 33.4587H36.6667L38.3924 11.8867M30.4167 33.4587V42.8337H20M30.4167 33.4587V17.8337M9.58333 33.4587V42.8337H20M9.58333 33.4587H3.33333L1.60758 11.8867M9.58333 33.4587V17.8337M20 7.41699L20 42.8337M1.60758 11.8867L20 11.2049L38.3924 11.8867"
                            stroke="#2A3F57" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                    <div class="characteristics__uniform-val">
                      {{ currentProfile.jacket }}
                    </div>
                  </div>
                  <div class="characteristics__uniform-item">
                    <div class="characteristics__uniform-img">
                      <svg width="42" height="44" viewBox="0 0 42 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M5.3737 6.37435L5.13088 5.93727C5.01227 6.00316 4.92554 6.11442 4.89058 6.24552L5.3737 6.37435ZM14.7487 1.16602V0.666016C14.6637 0.666016 14.5802 0.687671 14.5059 0.728937L14.7487 1.16602ZM27.2487 1.16602L27.4915 0.728937C27.4172 0.687671 27.3337 0.666016 27.2487 0.666016V1.16602ZM36.6237 6.37435L37.1068 6.24552C37.0719 6.11442 36.9851 6.00316 36.8665 5.93727L36.6237 6.37435ZM40.7904 21.9994L41.0904 22.3994C41.2536 22.2769 41.3261 22.0677 41.2735 21.8705L40.7904 21.9994ZM32.457 28.2494L32.157 27.8494C32.0311 27.9438 31.957 28.092 31.957 28.2494H32.457ZM32.457 42.8327V43.3327C32.7332 43.3327 32.957 43.1088 32.957 42.8327H32.457ZM9.54037 42.8327H9.04037C9.04037 43.1088 9.26422 43.3327 9.54037 43.3327V42.8327ZM9.54037 28.2494H10.0404C10.0404 28.092 9.96627 27.9438 9.84037 27.8494L9.54037 28.2494ZM1.20703 21.9994L0.723914 21.8705C0.671346 22.0677 0.743818 22.2769 0.907031 22.3994L1.20703 21.9994ZM9.04037 29.291C9.04037 29.5672 9.26422 29.791 9.54037 29.791C9.81651 29.791 10.0404 29.5672 10.0404 29.291H9.04037ZM10.0404 21.9993C10.0404 21.7232 9.81651 21.4993 9.54037 21.4993C9.26422 21.4993 9.04037 21.7232 9.04037 21.9993H10.0404ZM31.957 29.291C31.957 29.5672 32.1809 29.791 32.457 29.791C32.7332 29.791 32.957 29.5672 32.957 29.291H31.957ZM32.957 21.9993C32.957 21.7232 32.7332 21.4993 32.457 21.4993C32.1809 21.4993 31.957 21.7232 31.957 21.9993H32.957ZM5.61652 6.81143L14.9915 1.60309L14.5059 0.728937L5.13088 5.93727L5.61652 6.81143ZM27.0059 1.60309L36.3809 6.81143L36.8665 5.93727L27.4915 0.728937L27.0059 1.60309ZM36.1406 6.50318L40.3073 22.1282L41.2735 21.8705L37.1068 6.24552L36.1406 6.50318ZM40.4904 21.5994L32.157 27.8494L32.757 28.6494L41.0904 22.3994L40.4904 21.5994ZM31.957 28.2494V42.8327H32.957V28.2494H31.957ZM32.457 42.3327H9.54037V43.3327H32.457V42.3327ZM10.0404 42.8327V28.2494H9.04037V42.8327H10.0404ZM9.84037 27.8494L1.50703 21.5994L0.907031 22.3994L9.24037 28.6494L9.84037 27.8494ZM1.69015 22.1282L5.85682 6.50318L4.89058 6.24552L0.723914 21.8705L1.69015 22.1282ZM14.7487 1.16602C14.2507 1.12101 14.2507 1.1213 14.2507 1.12162C14.2507 1.12175 14.2506 1.12209 14.2506 1.12236C14.2506 1.12291 14.2505 1.12355 14.2504 1.12428C14.2503 1.12575 14.2502 1.1276 14.25 1.12982C14.2496 1.13426 14.2492 1.14018 14.2486 1.14754C14.2475 1.16226 14.2462 1.18275 14.2448 1.20862C14.242 1.26036 14.2391 1.33374 14.238 1.42571C14.2359 1.60945 14.2412 1.8686 14.27 2.1785C14.3275 2.79565 14.4801 3.62876 14.8661 4.47134C15.2538 5.31773 15.879 6.17703 16.8771 6.82704C17.8753 7.47713 19.2137 7.89654 20.9932 7.91599L21.0042 6.91605C19.3796 6.89829 18.2347 6.51784 17.4228 5.98908C16.6108 5.46024 16.099 4.76169 15.7752 4.05488C15.4497 3.34426 15.3163 2.62883 15.2657 2.08573C15.2405 1.8155 15.2362 1.5916 15.238 1.43733C15.2389 1.36029 15.2413 1.30092 15.2434 1.26215C15.2444 1.24278 15.2454 1.22858 15.246 1.21993C15.2463 1.2156 15.2465 1.21267 15.2467 1.21116C15.2467 1.21041 15.2468 1.21002 15.2468 1.21C15.2468 1.20998 15.2468 1.21006 15.2467 1.21023C15.2467 1.21032 15.2467 1.21051 15.2467 1.21056C15.2467 1.21078 15.2467 1.21102 14.7487 1.16602ZM20.9932 7.91599C22.7746 7.93546 24.1164 7.5359 25.118 6.89131C26.1192 6.24701 26.7449 5.38081 27.1322 4.52511C27.5179 3.67321 27.6701 2.82639 27.7275 2.19853C27.7563 1.88317 27.7615 1.61913 27.7594 1.43194C27.7583 1.33824 27.7554 1.2635 27.7526 1.21087C27.7512 1.18454 27.7499 1.16372 27.7488 1.1488C27.7483 1.14133 27.7479 1.13534 27.7475 1.13087C27.7473 1.12863 27.7472 1.12678 27.747 1.12531C27.747 1.12457 27.7469 1.12394 27.7469 1.12339C27.7469 1.12312 27.7468 1.12279 27.7468 1.12266C27.7468 1.12235 27.7468 1.12206 27.2487 1.16602C26.7506 1.20997 26.7506 1.20973 26.7506 1.20952C26.7506 1.20948 26.7506 1.20929 26.7506 1.20921C26.7506 1.20906 26.7506 1.209 26.7506 1.20903C26.7506 1.20909 26.7506 1.20952 26.7507 1.21033C26.7508 1.21194 26.751 1.21502 26.7513 1.21952C26.752 1.22852 26.7529 1.2432 26.754 1.26318C26.7561 1.30315 26.7585 1.36421 26.7594 1.4433C26.7612 1.60169 26.7568 1.83117 26.7316 2.10756C26.6808 2.6632 26.5471 3.39283 26.2212 4.11273C25.8971 4.82884 25.3858 5.52979 24.5769 6.05039C23.7683 6.5707 22.6269 6.93378 21.0042 6.91605L20.9932 7.91599ZM10.0404 29.291V21.9993H9.04037V29.291H10.0404ZM32.957 29.291V21.9993H31.957V29.291H32.957ZM14.7487 1.66602H27.2487V0.666016H14.7487V1.66602Z"
                            fill="#2A3F57"/>
                      </svg>
                    </div>
                    <div class="characteristics__uniform-val">
                      {{ currentProfile.shirt }}
                    </div>
                  </div>
                  <div class="characteristics__uniform-item">
                    <div class="characteristics__uniform-img">
                      <svg width="40" height="44" viewBox="0 0 40 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M29.375 42.8327L28.9046 43.002C28.976 43.2004 29.1642 43.3327 29.375 43.3327V42.8327ZM38.75 42.8327V43.3327C38.8913 43.3327 39.0259 43.2729 39.1207 43.1682C39.2155 43.0634 39.2616 42.9235 39.2475 42.7829L38.75 42.8327ZM34.5833 1.16602L35.0809 1.11626C35.0553 0.860663 34.8402 0.666016 34.5833 0.666016V1.16602ZM5.41667 1.16602V0.666016C5.15979 0.666016 4.94471 0.860663 4.91915 1.11626L5.41667 1.16602ZM1.25 42.8327L0.752481 42.7829C0.738425 42.9235 0.784485 43.0634 0.879274 43.1682C0.974063 43.2729 1.10874 43.3327 1.25 43.3327V42.8327ZM10.625 42.8327V43.3327C10.8358 43.3327 11.024 43.2004 11.0954 43.002L10.625 42.8327ZM20 16.791L20.4704 16.6217C20.399 16.4233 20.2108 16.291 20 16.291C19.7892 16.291 19.601 16.4233 19.5296 16.6217L20 16.791ZM20.5 1.16602C20.5 0.889873 20.2761 0.666016 20 0.666016C19.7239 0.666016 19.5 0.889873 19.5 1.16602H20.5ZM19.5 6.89518C19.5 7.17132 19.7239 7.39518 20 7.39518C20.2761 7.39518 20.5 7.17132 20.5 6.89518H19.5ZM12.7083 1.16602L13.2083 1.16602C13.2083 0.949992 13.0696 0.758396 12.8644 0.690984C12.6591 0.623572 12.4338 0.69559 12.3057 0.869541L12.7083 1.16602ZM4.27083 12.6243L3.86821 12.3279C3.74351 12.4972 3.73811 12.7265 3.85471 12.9016C3.97131 13.0766 4.18498 13.1599 4.38931 13.1101L4.27083 12.6243ZM27.7917 1.16602C27.7917 0.889873 27.5678 0.666016 27.2917 0.666016C27.0155 0.666016 26.7917 0.889873 26.7917 1.16602L27.7917 1.16602ZM35.6107 13.1101C35.879 13.1755 36.1495 13.0111 36.2149 12.7428C36.2804 12.4745 36.1159 12.204 35.8476 12.1386L35.6107 13.1101ZM29.375 43.3327H38.75V42.3327H29.375V43.3327ZM39.2475 42.7829L35.0809 1.11626L34.0858 1.21577L38.2525 42.8824L39.2475 42.7829ZM34.5833 0.666016H5.41667V1.66602H34.5833V0.666016ZM4.91915 1.11626L0.752481 42.7829L1.74752 42.8824L5.91419 1.21577L4.91915 1.11626ZM1.25 43.3327H10.625V42.3327H1.25V43.3327ZM11.0954 43.002L20.4704 16.9604L19.5296 16.6217L10.1546 42.6633L11.0954 43.002ZM19.5296 16.9604L28.9046 43.002L29.8454 42.6633L20.4704 16.6217L19.5296 16.9604ZM19.5 1.16602V6.89518H20.5V1.16602H19.5ZM12.7083 1.16602C12.2083 1.16602 12.2083 1.16596 12.2083 1.16592C12.2083 1.16594 12.2083 1.16593 12.2083 1.16597C12.2083 1.16606 12.2083 1.16623 12.2083 1.1665C12.2083 1.16704 12.2083 1.16795 12.2083 1.16923C12.2083 1.1718 12.2083 1.17585 12.2083 1.18133C12.2082 1.19231 12.2081 1.20904 12.2079 1.23122C12.2074 1.27558 12.2064 1.34169 12.2044 1.42701C12.2004 1.59771 12.1925 1.84507 12.1765 2.14885C12.1445 2.75718 12.0805 3.58803 11.9529 4.48072C11.8251 5.37541 11.6352 6.31996 11.3551 7.16024C11.0721 8.00913 10.7122 8.70507 10.2714 9.14579L10.9786 9.8529C11.5795 9.25196 12.0008 8.3854 12.3038 7.47647C12.6096 6.55894 12.8103 5.55037 12.9429 4.62214C13.0758 3.69192 13.142 2.83006 13.1751 2.20141C13.1917 1.8867 13.2 1.6295 13.2041 1.45026C13.2062 1.36062 13.2073 1.29042 13.2078 1.24221C13.2081 1.2181 13.2082 1.19949 13.2083 1.18668C13.2083 1.18028 13.2083 1.17533 13.2083 1.17187C13.2083 1.17014 13.2083 1.16879 13.2083 1.16781C13.2083 1.16732 13.2083 1.16693 13.2083 1.16663C13.2083 1.16648 13.2083 1.16632 13.2083 1.16625C13.2083 1.16612 13.2083 1.16602 12.7083 1.16602ZM10.2714 9.14579C9.30537 10.1119 7.79699 10.8628 6.48412 11.3776C5.83554 11.632 5.24988 11.8229 4.8267 11.9502C4.61532 12.0138 4.44503 12.0613 4.32837 12.0927C4.27005 12.1084 4.22517 12.1201 4.1953 12.1278C4.18037 12.1316 4.16919 12.1344 4.16197 12.1362C4.15836 12.1371 4.15573 12.1378 4.15412 12.1382C4.15332 12.1384 4.15277 12.1385 4.15247 12.1386C4.15232 12.1386 4.15224 12.1386 4.15222 12.1386C4.15221 12.1386 4.15224 12.1386 4.15224 12.1386C4.15229 12.1386 4.15235 12.1386 4.27083 12.6243C4.38931 13.1101 4.38941 13.1101 4.38953 13.1101C4.38959 13.11 4.38972 13.11 4.38984 13.11C4.39008 13.1099 4.39038 13.1098 4.39075 13.1098C4.39149 13.1096 4.39249 13.1093 4.39375 13.109C4.39626 13.1084 4.39979 13.1075 4.40433 13.1064C4.41339 13.1041 4.42645 13.1008 4.44331 13.0965C4.47702 13.0879 4.52593 13.0752 4.58846 13.0583C4.71349 13.0246 4.89314 12.9745 5.11471 12.9078C5.55741 12.7747 6.16967 12.5751 6.84921 12.3086C8.19259 11.7818 9.86129 10.9702 10.9786 9.8529L10.2714 9.14579ZM4.67345 12.9208L13.111 1.46249L12.3057 0.869541L3.86821 12.3279L4.67345 12.9208ZM27.2917 1.16602C26.7917 1.16602 26.7917 1.16612 26.7917 1.16625C26.7917 1.16632 26.7917 1.16648 26.7917 1.16663C26.7917 1.16693 26.7917 1.16732 26.7917 1.16781C26.7917 1.16879 26.7917 1.17014 26.7917 1.17187C26.7917 1.17533 26.7917 1.18028 26.7917 1.18668C26.7918 1.19949 26.7919 1.2181 26.7922 1.24221C26.7927 1.29042 26.7938 1.36062 26.7959 1.45026C26.8 1.6295 26.8083 1.8867 26.8249 2.20141C26.858 2.83006 26.9242 3.69192 27.0571 4.62214C27.1897 5.55037 27.3904 6.55894 27.6962 7.47647C27.9992 8.3854 28.4205 9.25196 29.0214 9.8529L29.7286 9.14579C29.2878 8.70507 28.9279 8.00913 28.6449 7.16024C28.3648 6.31996 28.1749 5.37541 28.0471 4.48072C27.9195 3.58803 27.8555 2.75718 27.8235 2.14885C27.8075 1.84507 27.7996 1.59771 27.7956 1.42701C27.7936 1.34169 27.7926 1.27558 27.7921 1.23122C27.7919 1.20904 27.7918 1.19231 27.7917 1.18133C27.7917 1.17585 27.7917 1.1718 27.7917 1.16923C27.7917 1.16795 27.7917 1.16704 27.7917 1.1665C27.7917 1.16623 27.7917 1.16606 27.7917 1.16597C27.7917 1.16593 27.7917 1.16594 27.7917 1.16592C27.7917 1.16596 27.7917 1.16602 27.2917 1.16602ZM29.0214 9.8529C30.1387 10.9702 31.8074 11.7818 33.1508 12.3086C33.8303 12.5751 34.4426 12.7747 34.8853 12.9078C35.1069 12.9745 35.2865 13.0246 35.4115 13.0583C35.4741 13.0752 35.523 13.0879 35.5567 13.0965C35.5735 13.1008 35.5866 13.1041 35.5957 13.1064C35.6002 13.1075 35.6037 13.1084 35.6062 13.109C35.6075 13.1093 35.6085 13.1096 35.6092 13.1098C35.6096 13.1098 35.6099 13.1099 35.6102 13.11C35.6103 13.11 35.6104 13.11 35.6105 13.1101C35.6106 13.1101 35.6107 13.1101 35.7292 12.6243C35.8476 12.1386 35.8477 12.1386 35.8478 12.1386C35.8478 12.1386 35.8478 12.1386 35.8478 12.1386C35.8478 12.1386 35.8477 12.1386 35.8475 12.1386C35.8472 12.1385 35.8467 12.1384 35.8459 12.1382C35.8443 12.1378 35.8416 12.1371 35.838 12.1362C35.8308 12.1344 35.8196 12.1316 35.8047 12.1278C35.7748 12.1201 35.7299 12.1084 35.6716 12.0927C35.555 12.0613 35.3847 12.0138 35.1733 11.9502C34.7501 11.8229 34.1645 11.632 33.5159 11.3776C32.203 10.8628 30.6946 10.1119 29.7286 9.14579L29.0214 9.8529Z"
                            fill="#2A3F57"/>
                      </svg>
                    </div>
                    <div class="characteristics__uniform-val">
                      {{ currentProfile.pants }}
                    </div>
                  </div>
                  <div class="characteristics__uniform-item">
                    <div class="characteristics__uniform-img">
                      <svg width="28" height="44" viewBox="0 0 28 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M27.4577 39.5585C27.4577 37.0003 26.7481 34.9329 25.883 34.5003L27.4577 1.16699H10.791L13.9062 32.8143L1.41602 38.6282V42.8337H27.4577V39.5585ZM27.4577 39.5585C27.4577 42.942 27.4576 38.5912 27.4577 39.5585ZM11.8327 9.50033H26.416"
                            stroke="#2A3F57" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                    <div class="characteristics__uniform-val">
                      {{ currentProfile.boots }}
                    </div>
                  </div>
                  <div class="characteristics__uniform-item">
                    <div class="characteristics__uniform-img">
                      <svg width="39" height="44" viewBox="0 0 39 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M23.167 20.9584V2.20841M30.4587 25.1251V14.7084V25.1251ZM30.4587 14.7084V13.6667C30.4587 7.77404 30.4587 4.82821 28.6284 2.99696C26.7972 1.16675 23.8514 1.16675 17.9587 1.16675H13.792C7.89928 1.16675 4.95345 1.16675 3.1222 2.99696C1.29199 4.82821 1.29199 7.77404 1.29199 13.6667V42.8334H30.4587V35.5418C30.4587 35.5418 37.7503 35.5418 37.7503 29.2918V20.9584C37.7503 14.7084 30.4587 14.7084 30.4587 14.7084ZM8.58366 20.9584V2.20841V20.9584ZM15.8753 20.9584V2.20841V20.9584Z"
                            stroke="#2A3F57" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>

                    </div>
                    <div class="characteristics__uniform-val">
                      {{ currentProfile.gloves }}
                    </div>
                  </div>
                </div>
              </div>

              <router-link v-if="!profile || permissions.admin" class="btn btn-primary link-not-like"
                           :to="'/workers/' + id + '/timings'">
                {{ $vuetify.lang.t('$vuetify.menu.timings') }}
              </router-link>
              <!--              <div class="characteristics__list">-->
              <!--              </div>-->
            </div>

            <div v-if="editing">
              <div class="sign-up__form sign-up__form--profile">

                <v-text-field v-model="currentProfile.phone" :label="$vuetify.lang.t('$vuetify.phone')" outlined
                              :rules="[$rules.required]">
                </v-text-field>
                <v-text-field v-model="currentProfile.auth_user_id.email" label="E-mail" outlined
                              :rules="[$rules.required, $rules.email]"></v-text-field>
                <v-autocomplete v-if="permissions.admin && !profile" v-model="currentGroup"
                                :label="$vuetify.lang.t('$vuetify.systemRole')"
                                :items="groups" item-text="name" item-value="id" return-object outlined attach
                                :menu-props="{
                  bottom: true,
                  maxHeight: 150,
                  contentClass: 'select-menu',
                }">
                  <template v-slot:item="{ item }">
                    {{
                      item.name[$vuetify.lang.current] ? item.name[$vuetify.lang.current] : item.name['eng'] ? item.name['eng'] : item.name['fin']
                    }}
                  </template>
                  <template v-slot:selection="{ item }">
                    {{
                      item.name[$vuetify.lang.current] ? item.name[$vuetify.lang.current] : item.name['eng'] ? item.name['eng'] : item.name['fin']
                    }}
                  </template>
                </v-autocomplete>
                <v-text-field v-model="currentProfile.citizenship" :label="$vuetify.lang.t('$vuetify.citizenship')"
                              outlined></v-text-field>
                <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field :value="new Date(currentProfile.birthdate).toLocaleDateString('ru-Ru')"
                                  :label="$vuetify.lang.t('$vuetify.birthday')" append-icon="$calendar" v-bind="attrs"
                                  v-on="on"
                                  outlined readonly></v-text-field>
                  </template>
                  <v-date-picker v-model="currentProfile.birthdate" @input="menu1 = false"
                                 no-title first-day-of-week="1" show-week locale-first-day-of-year="4"
                                 show-adjacent-months></v-date-picker>
                </v-menu>
                <div class="form__radio">
                  <div class="form__radio-single custom-radio">
                    <input class="custom-radio__hide" type="radio" name="from-finland" value="yes" id="from-finland-yes"
                           v-model="options.address"/>
                    <label class="custom-radio__button" for="from-finland-yes">
                      <span></span></label>
                    <label for="from-finland-yes">{{ $vuetify.lang.t('$vuetify.fromFinland') }}</label>
                  </div>
                  <div class="form__radio-single custom-radio">
                    <input class="custom-radio__hide" type="radio" name="from-finland" value="no" id="from-finland-no"
                           v-model="options.address"/>
                    <label class="custom-radio__button" for="from-finland-no"><span></span></label>
                    <label for="from-finland-no">{{ $vuetify.lang.t('$vuetify.fromAnotherCountry') }}</label>
                  </div>
                </div>
                <v-text-field v-model="currentProfile.social_code_fin"
                              :label="$vuetify.lang.t('$vuetify.socialCodeFin')" outlined
                ></v-text-field>
                <v-text-field v-model="currentProfile.tax_number" label="Veronumero" outlined
                >
                </v-text-field>
                <v-text-field v-model="currentProfile.bank_account" :label="$vuetify.lang.t('$vuetify.bankAccount')"
                              outlined></v-text-field>
              </div>
              <div class="sign-up__form sign-up__form--profile">

                <div class="form__row form__address">
                  <v-text-field class="address__street" v-model="currentProfile.address_fin.street"
                                :label="$vuetify.lang.t('$vuetify.street')"
                                outlined></v-text-field>
                  <v-text-field class="address__house" v-model="currentProfile.address_fin.house"
                                :label="$vuetify.lang.t('$vuetify.house')" outlined
                  ></v-text-field>
                  <v-text-field class="address__entrance" v-model="currentProfile.address_fin.entrance" label="Подъезд"
                                outlined></v-text-field>
                  <v-text-field class="address__flat" v-model="currentProfile.address_fin.flat"
                                :label="$vuetify.lang.t('$vuetify.flat')"
                                outlined></v-text-field>
                </div>
                <div class="form__row form__address">
                  <v-text-field class="address__index" v-model="currentProfile.address_fin.index" label="Индекс"
                                outlined></v-text-field>
                  <v-text-field class="address__city" v-model="currentProfile.address_fin.city"
                                :label="$vuetify.lang.t('$vuetify.city')" outlined
                  ></v-text-field>
                </div>
                <div v-if="options.address === 'no'">
                  <div class="h2">Адрес в родной стране</div>
                  <div class="form__row form__address">
                    <v-text-field class="address__street" v-model="currentProfile.address_own.street"
                                  :label="$vuetify.lang.t('$vuetify.street')" outlined
                    ></v-text-field>
                    <v-text-field class="address__house" v-model="currentProfile.address_own.house"
                                  :label="$vuetify.lang.t('$vuetify.house')" outlined
                    ></v-text-field>
                    <v-text-field class="address__entrance" v-model="currentProfile.address_own.entrance"
                                  :label="$vuetify.lang.t('$vuetify.entrance')" outlined></v-text-field>
                    <v-text-field class="address__flat" v-model="currentProfile.address_own.flat"
                                  :label="$vuetify.lang.t('$vuetify.flat')" outlined></v-text-field>
                  </div>
                  <div class="form__row form__address">
                    <v-text-field class="address__index" v-model="currentProfile.address_own.index" label="Индекс"
                                  outlined></v-text-field>
                    <v-text-field class="address__city" v-model="currentProfile.address_own.city" label="Город" outlined
                    ></v-text-field>
                  </div>
                  <v-text-field class="address__country" v-model="currentProfile.address_own.country" label="Страна"
                                outlined></v-text-field>
                </div>
              </div>

              <div class="h2">{{ $vuetify.lang.t('$vuetify.editAdditional') }}</div>
              <div class="sign-up__form sign-up__form--profile form__grid">
                <div class="form__lang">
                  <div class="h2">{{ $vuetify.lang.t('$vuetify.languages') }}</div>
                  <v-checkbox v-model="currentProfile.english" label="English"></v-checkbox>
                  <v-checkbox v-model="currentProfile.estonian" label="Eesti"></v-checkbox>
                  <v-checkbox v-model="currentProfile.finnish" label="Suomi"></v-checkbox>
                  <v-checkbox v-model="currentProfile.russian" label="Русский"></v-checkbox>
                  <div class="form__row">
                    <v-checkbox v-model="other_language_check" label="Другие"></v-checkbox>
                    <v-text-field v-model="currentProfile.other_language" :disabled="!other_language_check">
                    </v-text-field>
                  </div>
                </div>
                <div class="form__auto">
                  <div class="h2">{{ $vuetify.lang.t('$vuetify.additional') }}</div>
                  <v-checkbox v-model="currentProfile.auto" :label="$vuetify.lang.t('$vuetify.haveOwnCar')">
                  </v-checkbox>
                  <v-checkbox v-model="currentProfile.tool" :label="$vuetify.lang.t('$vuetify.haveOwnTools')">
                  </v-checkbox>
                  <div>{{ $vuetify.lang.t('$vuetify.driverLicenseCat') }}</div>
                  <div class="form__auto-category">
                    <v-checkbox v-model="currentProfile.auto_category" label="A" value="A"></v-checkbox>
                    <v-checkbox v-model="currentProfile.auto_category" label="B" value="B"></v-checkbox>
                    <v-checkbox v-model="currentProfile.auto_category" label="C" value="C"></v-checkbox>
                    <v-checkbox v-model="currentProfile.auto_category" label="D" value="D"></v-checkbox>
                    <v-checkbox v-model="currentProfile.auto_category" label="E" value="E"></v-checkbox>
                    <v-checkbox v-model="currentProfile.auto_category" label="F" value="F"></v-checkbox>
                  </div>
                </div>
              </div>

              <div class="form__clothes">
                <div class="h2">{{ $vuetify.lang.t('$vuetify.sizeUniform') }}</div>
                <div class="form__grid">
                  <div class="form__row">
                    <span class="clothes__title">{{ $vuetify.lang.t('$vuetify.shirt') }}</span>
                    <v-text-field v-model="currentProfile.shirt" :label="$vuetify.lang.t('$vuetify.size')" outlined>
                    </v-text-field>

                  </div>
                  <div class="form__row">
                    <span class="clothes__title">{{ $vuetify.lang.t('$vuetify.pants') }}</span>
                    <v-text-field v-model="currentProfile.pants" :label="$vuetify.lang.t('$vuetify.size')" outlined>
                    </v-text-field>

                  </div>
                  <div class="form__row">
                    <span class="clothes__title">{{ $vuetify.lang.t('$vuetify.jacket') }}</span>
                    <v-text-field v-model="currentProfile.jacket" :label="$vuetify.lang.t('$vuetify.size')" outlined>
                    </v-text-field>

                  </div>
                  <div class="form__row">
                    <span class="clothes__title">{{ $vuetify.lang.t('$vuetify.boots') }}</span>
                    <v-text-field v-model="currentProfile.boots" :label="$vuetify.lang.t('$vuetify.size')" outlined>
                    </v-text-field>

                  </div>

                  <div class="form__row">
                    <span class="clothes__title">{{ $vuetify.lang.t('$vuetify.gloves') }}</span>
                    <v-text-field v-model="currentProfile.gloves" :label="$vuetify.lang.t('$vuetify.size')" outlined>
                    </v-text-field>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="tab_selected === 2" class="profile-tabs__content-item">
            <div class="info-cards" v-if="!editing">
              <template v-for="(card) in currentProfile.cards">
                <div :key="card.id" v-if="profile || card.show">
                  <div class="h2">
                    {{
                      card.card.name ?
                          (card.card.name[$vuetify.lang.current] ? card.card.name[$vuetify.lang.current] : card.card.name['eng'] ? card.card.name['eng'] : card.card.name['fin']) :
                          (card.name[$vuetify.lang.current] ? card.name[$vuetify.lang.current] : card.name['eng'] ? card.name['eng'] : card.name['fin'])
                    }}
                  </div>
                  <div class="info-cards__item">
                    <div class="info-cards__image">
                      <img v-if="card.photo_path" :src="$media_url + card.photo_path" alt=""
                           @click="lightboxItems.push($media_url+card.photo_path);
                           card.photo_path_2 ? lightboxItems.push($media_url+card.photo_path_2) : index=0;
                           index=0"/>
                    </div>
                    <div class="info-cards__characteristics">
                      <div class="characteristics__item">
                        <div class="characteristics__title">{{ $vuetify.lang.t('$vuetify.cardNumber') }}</div>
                        <div class="characteristics__val">{{ card.number }}</div>
                      </div>
                      <div class="characteristics__item">
                        <div class="characteristics__title">{{ $vuetify.lang.t('$vuetify.dueDate') }}</div>
                        <div class="characteristics__val" :class="{ 'red': new Date(card.due_date) <= new Date() }">
                          {{ new Date(card.due_date).toLocaleDateString(options_date) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>

            <div v-if="editing">
              <v-select v-model="selectedCard" :items="cards" outlined
                        :placeholder="'+ ' + $vuetify.lang.t('$vuetify.addCard')" item-text="name" item-value="id"
                        return-object attach
                        @change="addCard" :menu-props="{
                  bottom: true,
                  offsetY: true,
                  maxHeight: 200,
                  contentClass: 'select-menu',
                }">
                <template v-slot:item="{ item }">
                  {{
                    item.name[$vuetify.lang.current] ? item.name[$vuetify.lang.current] : item.name['eng'] ? item.name['eng'] : item.name['fin']
                  }}
                </template>
              </v-select>
              <template>
                <div class="cards--editing">
                  <div :key="card.id" v-for="(card, idx) in currentProfile.cards">
                    <div class="h2">
                      {{
                        card.card.name ?
                            (card.card.name[$vuetify.lang.current] ? card.card.name[$vuetify.lang.current] : card.card.name['eng'] ? card.card.name['eng'] : card.card.name['fin']) :
                            (card.name[$vuetify.lang.current] ? card.name[$vuetify.lang.current] : card.name['eng'] ? card.name['eng'] : card.name['fin'])
                      }}
                    </div>
                    <div class="form__row form__card">
                      <div>
                        <div class="card__photo" @click="clickCardInput(idx)">
                          <img v-if="(card.tmp_file || card.photo_path)"
                               :src="card.tmp_file || $media_url + card.photo_path"
                               alt="photo"/>
                          <div v-else class="text-center text-caption">{{
                              $vuetify.lang.t("$vuetify.frontPhoto")
                            }}
                          </div>
                          <v-file-input class="file-input--hide" v-model="card.photo"
                                        :placeholder="$vuetify.lang.t('$vuetify.uploadImg')" :id="'photo' + idx"
                                        accept=".jpg, .png, .jpeg" @change="showFile(this, idx)"></v-file-input>
                        </div>
                        <div class="card__photo" @click="clickCardInput(idx + '-2')">
                          <img v-if="(card.tmp_file_2 || card.photo_path_2)"
                               :src="card.tmp_file_2 || $media_url + card.photo_path_2"
                               alt="photo"/>
                          <div v-else class="text-center text-caption">{{ $vuetify.lang.t("$vuetify.backPhoto") }}</div>
                          <v-file-input class="file-input--hide" v-model="card.photo_2"
                                        :placeholder="$vuetify.lang.t('$vuetify.uploadImg')" :id="'photo' + idx + '-2'"
                                        accept=".jpg, .png, .jpeg" @change="showFile(this, idx + '-2')"></v-file-input>
                        </div>
                      </div>
                      <div>
                        <v-checkbox v-if="permissions.admin" v-model="card.show"
                                    :label="$vuetify.lang.t('$vuetify.showQua')"></v-checkbox>
                        <v-text-field class="card__number" v-model="card.number"
                                      :label="$vuetify.lang.t('$vuetify.cardNumber')" outlined
                                      :rules="[$rules.required]">
                        </v-text-field>
                        <div class="form__row">
                          <v-menu ref="menuCard" v-model="menuCard[idx]" :close-on-content-click="false"
                                  transition="scale-transition">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field class="card__date"
                                            :value="card.due_date ? new Date(card.due_date).toLocaleDateString('ru-Ru') : ''"
                                            :label="$vuetify.lang.t('$vuetify.dueDate')" readonly v-bind="attrs"
                                            v-on="on"
                                            outlined>
                              </v-text-field>
                            </template>
                            <v-date-picker v-model="card.due_date" @input="menuCard[idx] = false"
                                           no-title first-day-of-week="1" show-week locale-first-day-of-year="4"
                                           show-adjacent-months
                                           :min="new Date(Date.now()).toISOString().substr(0, 7)"></v-date-picker>
                          </v-menu>
                          <button class="btn btn-error" @click="deleteCard(idx)">
                            {{ $vuetify.lang.t('$vuetify.deleteCard') }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div v-if="tab_selected === 3" class="profile-tabs__content-item">
            <div class="work-list">
              <template v-if="!editing">
                <div class="work-list__item" v-for="skill in currentProfile.other_positions" :key="skill.id">
                  {{
                    skill.name[$vuetify.lang.current] ? skill.name[$vuetify.lang.current] : skill.name['eng'] ? skill.name['eng'] : skill.name['fin']
                  }}
                </div>
              </template>
              <div v-if="editing">
                <v-select v-model="selectedPosition" :items="positionsSelect" outlined
                          :placeholder="'+ ' + $vuetify.lang.t('$vuetify.add')"
                          item-text="name" item-value="id"
                          return-object attach
                          @change="addPosition" :menu-props="{
                  bottom: true,
                  offsetY: true,
                  maxHeight: 200,
                  contentClass: 'select-menu',
                }">
                  <template v-slot:selection="{ item }">
                    {{
                      item.name[$vuetify.lang.current] ? item.name[$vuetify.lang.current] : item.name['eng'] ? item.name['eng'] : item.name['fin']
                    }}
                  </template>
                  <template v-slot:item="{ item }">
                    {{
                      item.name[$vuetify.lang.current] ? item.name[$vuetify.lang.current] : item.name['eng'] ? item.name['eng'] : item.name['fin']
                    }}
                  </template>
                </v-select>
                <div class="work-list__item flex justify-between" v-for="(skill,i) in currentProfile.other_positions"
                     :key="skill.id">
                  <span>
                    {{
                      skill.name[$vuetify.lang.current] ? skill.name[$vuetify.lang.current] : skill.name['eng'] ? skill.name['eng'] : skill.name['fin']
                    }}
                  </span>
                  <button class="btn-icon" @click="deletePosition(i)">
                    <v-icon>mdi-close</v-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="tab_selected === 4" class="profile-tabs__content-item">
            <div class="profile-objects">
              <div class="profile-objects-list">
                <div class="h2" @click="switch_object_list('start')">{{ $vuetify.lang.t('$vuetify.planning') }}</div>
                <div class="list" :class="{ 'm-hidden': objects_list_vis.start }">
                  <ProfileObjectCard v-for="object in objects.start" :key="object.id" :object_link="true"
                                     :object_name="object.objects_id.name" :object_id="object.objects_id.id"
                                     :start_date="object.start_date"
                                     :end_date="object.end_date" :client_id="object.objects_id.client_id.id"
                                     :client_logo="
                      object.objects_id.client_id.logo_path
                        ? object.objects_id.client_id.logo_path
                        : ''
                    " :client_name="object.objects_id.client_id.name"></ProfileObjectCard>
                </div>

              </div>
              <div class="profile-objects-list">
                <div class="h2" @click="switch_object_list('now')">{{ $vuetify.lang.t('$vuetify.inProgress') }}</div>
                <div class="list" :class="{ 'm-hidden': objects_list_vis.now }">

                  <ProfileObjectCard v-for="object in objects.now" :key="object.id" :object_link="true"
                                     :object_name="object.objects_id.name" :object_id="object.objects_id.id"
                                     :start_date="object.start_date"
                                     :end_date="object.end_date" :client_id="object.objects_id.client_id.id"
                                     :client_logo="
                      object.objects_id.client_id.logo_path
                        ? object.objects_id.client_id.logo_path
                        : ''
                    " :client_name="object.objects_id.client_id.name"></ProfileObjectCard>
                </div>
              </div>
              <div class="profile-objects-list">
                <div class="list" :class="{ 'm-hidden': objects_list_vis.end }">

                  <div class="h2" @click="switch_object_list('end')">{{ $vuetify.lang.t('$vuetify.finished') }}</div>
                  <ProfileObjectCard v-for="object in objects.end" :key="object.id" :object_link="true"
                                     :object_name="object.objects_id.name" :object_id="object.objects_id.id"
                                     :start_date="object.start_date"
                                     :end_date="object.end_date" :client_id="object.objects_id.client_id.id"
                                     :client_logo="
                      object.objects_id.client_id.logo_path
                        ? object.objects_id.client_id.logo_path
                        : ''
                    " :client_name="object.objects_id.client_id.name"></ProfileObjectCard>
                </div>
              </div>
            </div>
          </div>
          <div v-if="tab_selected === 6" class="profile-tabs__content-item">
            <div class="documents">
              <div class="page__sorts">
                <button class="btn btn-secondary mt-20 mb-40"
                        v-if="(permissions.edit.indexOf('Работники') !== -1 && organizations.indexOf(company) !== -1) || profile"
                        @click="addDocumentModal = true; docs = null; newDocument.user_profile_id = currentProfile.id">
                  + {{ $vuetify.lang.t('$vuetify.addDocument') }}
                </button>
                <div class="documents__sorts">
                  <div class="sorts__radio">
                    <span>{{ $vuetify.lang.t('$vuetify.dataTable.sortBy') }}</span>
                    <div class="custom-radio">
                      <input v-model="sort" type="radio" name="sort" value="name" id="sort9"
                             class="custom-radio__hide"/>
                      <label for="sort9" class="custom-radio__button"><span></span></label>
                      <label for="sort9">{{ $vuetify.lang.t('$vuetify.sorts.byName') }}</label>
                    </div>
                    <div class="custom-radio">
                      <input v-model="sort" type="radio" name="sort" value="create_date" id="sort7"
                             class="custom-radio__hide"/>
                      <label for="sort7" class="custom-radio__button"><span></span></label>
                      <label for="sort7">{{ $vuetify.lang.t('$vuetify.sorts.byCreateDate') }}</label>
                    </div>
                  </div>
                  <v-select class="sorts__select" v-model="sort"
                            :label="$vuetify.lang.t('$vuetify.dataTable.sortBy')"
                            :items="selectSorts" item-text="name" item-value="value"
                            :menu-props="{
                                                      bottom: true,
                                                      offsetY: true,
                                                      maxHeight: 200,
                                                      contentClass: 'select-menu',
                                                  }"
                            outlined hide-details attach></v-select>
                </div>
              </div>

              <div class="page__sorts">
                <div class="page-head--right">
                  <div class="type-switcher">
                    <div class="type-switcher__item" :class="{ show: type == 'rows' }" @click="type = 'rows'">
                      <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="0.5" width="33" height="33" rx="4.5"/>
                        <path
                            d="M9.20039 9.7998C8.723 9.7998 8.26516 9.98945 7.9276 10.327C7.59003 10.6646 7.40039 11.1224 7.40039 11.5998V13.9998C7.40039 14.4772 7.59003 14.935 7.9276 15.2726C8.26516 15.6102 8.723 15.7998 9.20039 15.7998H11.6004C12.0778 15.7998 12.5356 15.6102 12.8732 15.2726C13.2107 14.935 13.4004 14.4772 13.4004 13.9998V11.5998C13.4004 11.1224 13.2107 10.6646 12.8732 10.327C12.5356 9.98945 12.0778 9.7998 11.6004 9.7998H9.20039ZM8.60039 11.5998C8.60039 11.4407 8.6636 11.2881 8.77613 11.1755C8.88865 11.063 9.04126 10.9998 9.20039 10.9998H11.6004C11.7595 10.9998 11.9121 11.063 12.0247 11.1755C12.1372 11.2881 12.2004 11.4407 12.2004 11.5998V13.9998C12.2004 14.1589 12.1372 14.3115 12.0247 14.4241C11.9121 14.5366 11.7595 14.5998 11.6004 14.5998H9.20039C9.04126 14.5998 8.88865 14.5366 8.77613 14.4241C8.6636 14.3115 8.60039 14.1589 8.60039 13.9998V11.5998ZM16.4004 10.9998C16.2413 10.9998 16.0886 11.063 15.9761 11.1755C15.8636 11.2881 15.8004 11.4407 15.8004 11.5998C15.8004 11.7589 15.8636 11.9115 15.9761 12.0241C16.0886 12.1366 16.2413 12.1998 16.4004 12.1998H26.0004C26.1595 12.1998 26.3121 12.1366 26.4247 12.0241C26.5372 11.9115 26.6004 11.7589 26.6004 11.5998C26.6004 11.4407 26.5372 11.2881 26.4247 11.1755C26.3121 11.063 26.1595 10.9998 26.0004 10.9998H16.4004ZM16.4004 13.3998C16.2413 13.3998 16.0886 13.463 15.9761 13.5755C15.8636 13.6881 15.8004 13.8407 15.8004 13.9998C15.8004 14.1589 15.8636 14.3115 15.9761 14.4241C16.0886 14.5366 16.2413 14.5998 16.4004 14.5998H23.6004C23.7595 14.5998 23.9121 14.5366 24.0247 14.4241C24.1372 14.3115 24.2004 14.1589 24.2004 13.9998C24.2004 13.8407 24.1372 13.6881 24.0247 13.5755C23.9121 13.463 23.7595 13.3998 23.6004 13.3998H16.4004ZM9.20039 18.1998C8.723 18.1998 8.26516 18.3894 7.9276 18.727C7.59003 19.0646 7.40039 19.5224 7.40039 19.9998V22.3998C7.40039 22.8772 7.59003 23.335 7.9276 23.6726C8.26516 24.0102 8.723 24.1998 9.20039 24.1998H11.6004C12.0778 24.1998 12.5356 24.0102 12.8732 23.6726C13.2107 23.335 13.4004 22.8772 13.4004 22.3998V19.9998C13.4004 19.5224 13.2107 19.0646 12.8732 18.727C12.5356 18.3894 12.0778 18.1998 11.6004 18.1998H9.20039ZM8.60039 19.9998C8.60039 19.8407 8.6636 19.6881 8.77613 19.5755C8.88865 19.463 9.04126 19.3998 9.20039 19.3998H11.6004C11.7595 19.3998 11.9121 19.463 12.0247 19.5755C12.1372 19.6881 12.2004 19.8407 12.2004 19.9998V22.3998C12.2004 22.5589 12.1372 22.7115 12.0247 22.8241C11.9121 22.9366 11.7595 22.9998 11.6004 22.9998H9.20039C9.04126 22.9998 8.88865 22.9366 8.77613 22.8241C8.6636 22.7115 8.60039 22.5589 8.60039 22.3998V19.9998ZM16.4004 19.3998C16.2413 19.3998 16.0886 19.463 15.9761 19.5755C15.8636 19.6881 15.8004 19.8407 15.8004 19.9998C15.8004 20.1589 15.8636 20.3115 15.9761 20.4241C16.0886 20.5366 16.2413 20.5998 16.4004 20.5998H26.0004C26.1595 20.5998 26.3121 20.5366 26.4247 20.4241C26.5372 20.3115 26.6004 20.1589 26.6004 19.9998C26.6004 19.8407 26.5372 19.6881 26.4247 19.5755C26.3121 19.463 26.1595 19.3998 26.0004 19.3998H16.4004ZM16.4004 21.7998C16.2413 21.7998 16.0886 21.863 15.9761 21.9755C15.8636 22.0881 15.8004 22.2407 15.8004 22.3998C15.8004 22.5589 15.8636 22.7115 15.9761 22.8241C16.0886 22.9366 16.2413 22.9998 16.4004 22.9998H23.6004C23.7595 22.9998 23.9121 22.9366 24.0247 22.8241C24.1372 22.7115 24.2004 22.5589 24.2004 22.3998C24.2004 22.2407 24.1372 22.0881 24.0247 21.9755C23.9121 21.863 23.7595 21.7998 23.6004 21.7998H16.4004Z"
                            fill="#2A3F57"/>
                        <rect x="0.5" y="0.5" width="33" height="33" rx="4.5" stroke="#2A3F57"/>
                      </svg>
                    </div>
                    <div class="type-switcher__item" :class="{ show: type == 'cards' }" @click="type = 'cards'">
                      <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M15.5738 8.86902C14.9918 8.3126 14.2024 8 13.3793 8H11.1034C10.2804 8 9.49099 8.3126 8.90898 8.86902C8.32697 9.42545 8 10.1801 8 10.967V13.5385C8 14.3254 8.32697 15.08 8.90898 15.6365C9.49099 16.1929 10.2804 16.5055 11.1034 16.5055H13.3793C14.2024 16.5055 14.9918 16.1929 15.5738 15.6365C16.1558 15.08 16.4828 14.3254 16.4828 13.5385V10.967C16.4828 10.1801 16.1558 9.42545 15.5738 8.86902ZM9.24138 13.5385V10.967C9.24138 10.4949 9.43756 10.0421 9.78677 9.70823C10.136 9.37437 10.6096 9.18681 11.1034 9.18681H13.3793C13.8732 9.18681 14.3468 9.37437 14.696 9.70823C15.0452 10.0421 15.2414 10.4949 15.2414 10.967V13.5385C15.2414 14.0106 15.0452 14.4634 14.696 14.7973C14.3468 15.1311 13.8732 15.3187 13.3793 15.3187H11.1034C10.6096 15.3187 10.136 15.1311 9.78677 14.7973C9.43756 14.4634 9.24138 14.0106 9.24138 13.5385Z"
                              fill="#2A3F57"/>
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M25.091 8.86902C24.509 8.3126 23.7196 8 22.8966 8H20.6207C19.7976 8 19.0082 8.3126 18.4262 8.86902C17.8442 9.42545 17.5172 10.1801 17.5172 10.967V13.5385C17.5172 14.3254 17.8442 15.08 18.4262 15.6365C19.0082 16.1929 19.7976 16.5055 20.6207 16.5055H22.8966C23.7196 16.5055 24.509 16.1929 25.091 15.6365C25.673 15.08 26 14.3254 26 13.5385V10.967C26 10.1801 25.673 9.42545 25.091 8.86902ZM18.7586 13.5385V10.967C18.7586 10.4949 18.9548 10.0421 19.304 9.70823C19.6532 9.37437 20.1268 9.18681 20.6207 9.18681H22.8966C23.3904 9.18681 23.864 9.37437 24.2132 9.70823C24.5624 10.0421 24.7586 10.4949 24.7586 10.967V13.5385C24.7586 14.0106 24.5624 14.4634 24.2132 14.7973C23.864 15.1311 23.3904 15.3187 22.8966 15.3187H20.6207C20.1268 15.3187 19.6532 15.1311 19.304 14.7973C18.9548 14.4634 18.7586 14.0106 18.7586 13.5385Z"
                              fill="#2A3F57"/>
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M15.5738 18.3635C14.9918 17.8071 14.2024 17.4945 13.3793 17.4945H11.1034C10.2804 17.4945 9.49099 17.8071 8.90898 18.3635C8.32697 18.92 8 19.6746 8 20.4615V23.033C8 23.8199 8.32697 24.5745 8.90898 25.131C9.49099 25.6874 10.2804 26 11.1034 26H13.3793C14.2024 26 14.9918 25.6874 15.5738 25.131C16.1558 24.5745 16.4828 23.8199 16.4828 23.033V20.4615C16.4828 19.6746 16.1558 18.92 15.5738 18.3635ZM9.24138 23.033V20.4615C9.24138 19.9894 9.43756 19.5366 9.78677 19.2027C10.136 18.8689 10.6096 18.6813 11.1034 18.6813H13.3793C13.8732 18.6813 14.3468 18.8689 14.696 19.2027C15.0452 19.5366 15.2414 19.9894 15.2414 20.4615V23.033C15.2414 23.5051 15.0452 23.9579 14.696 24.2918C14.3468 24.6256 13.8732 24.8132 13.3793 24.8132H11.1034C10.6096 24.8132 10.136 24.6256 9.78677 24.2918C9.43756 23.9579 9.24138 23.5051 9.24138 23.033Z"
                              fill="#2A3F57"/>
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M25.091 18.3635C24.509 17.8071 23.7196 17.4945 22.8966 17.4945H20.6207C19.7976 17.4945 19.0082 17.8071 18.4262 18.3635C17.8442 18.92 17.5172 19.6746 17.5172 20.4615V23.033C17.5172 23.8199 17.8442 24.5745 18.4262 25.131C19.0082 25.6874 19.7976 26 20.6207 26H22.8966C23.7196 26 24.509 25.6874 25.091 25.131C25.673 24.5745 26 23.8199 26 23.033V20.4615C26 19.6746 25.673 18.92 25.091 18.3635ZM18.7586 23.033V20.4615C18.7586 19.9894 18.9548 19.5366 19.304 19.2027C19.6532 18.8689 20.1268 18.6813 20.6207 18.6813H22.8966C23.3904 18.6813 23.864 18.8689 24.2132 19.2027C24.5624 19.5366 24.7586 19.9894 24.7586 20.4615V23.033C24.7586 23.5051 24.5624 23.9579 24.2132 24.2918C23.864 24.6256 23.3904 24.8132 22.8966 24.8132H20.6207C20.1268 24.8132 19.6532 24.6256 19.304 24.2918C18.9548 23.9579 18.7586 23.5051 18.7586 23.033Z"
                              fill="#2A3F57"/>
                        <rect x="0.5" y="0.5" width="33" height="33" rx="4.5" stroke="#2A3F57"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              <BaseTable :headers="headersDocuments" :type="type" :draggable_mode="false"
                         :show-headers="showHeadersDocuments" :sort="sort"
              >
                <template #cards="{ type,  headers, showHeaders }">
                  <BaseCard v-for="doc in documents" :key="doc.id" :type="type" :headers="headers"
                            :show-headers="showHeaders" :cp="true"
                            :title="doc.name" :photo="doc.path" :card="doc" :options="doc.options"
                            :show-archive="false"
                            :show-edit="permissions.edit.indexOf('Гараж') !== -1"
                            :show-delete="permissions.edit.indexOf('Гараж') !== -1"
                            @edit="newDocument = doc; docs = null; addDocumentModal = true;"
                            @delete="confirm_document_open(doc.id)"
                            @open="openFile(doc)"
                            @open-photo="openFile(doc)"
                            @download-document="downloadDocument(doc)"
                  />
                </template>
              </BaseTable>
            </div>
          </div>
        </div>
      </div>

      <div class="profile-tabs cards__single">
        <div class="profile-tabs__head">
          <div class="profile-tabs__item" :class="{ selected: tab_selected_1 === 1 }" @click="tab_selected_1 = 1">
            {{ $vuetify.lang.t('$vuetify.cvs.aboutMe') }}
          </div>
          <div class="profile-tabs__item" :class="{ selected: tab_selected_1 === 4 }" @click="tab_selected_1 = 4">
            {{ $vuetify.lang.t('$vuetify.portfolio') }}
          </div>
          <div class="profile-tabs__item" :class="{ selected: tab_selected_1 === 7 }" @click="tab_selected_1 = 7">
            {{ $vuetify.lang.t('$vuetify.cv') }}
          </div>
        </div>
        <div class="profile-tabs__content ">
          <div v-if="tab_selected_1 ===1" class="profile-tabs__content-item">
            <div v-if="!editing" v-html="currentProfile.about_me"></div>
            <div v-if="editing">
              <text-editor v-model="currentProfile.about_me"></text-editor>
            </div>
          </div>
          <div v-if="tab_selected_1 ===4" class="profile-tabs__content-item">
            <div>
              <div class="page__sorts">
                <v-menu ref="date" v-model="portfolioDate"
                        :close-on-content-click="false" transition="scale-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field class="search-field" :value="portfolioFilter.range.join(' ~ ')"
                                  @keypress.enter="loadPortfolio()" prepend-inner-icon="$calendar"
                                  :placeholder="$vuetify.lang.t('$vuetify.accounting.card.period')" outlined
                                  hide-details v-bind="attrs" v-on="on" readonly clearable
                                  @click:clear="portfolioFilter.range=[]; loadPortfolio()">
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="portfolioFilter.range" no-title first-day-of-week="1" show-week
                                 locale-first-day-of-year="4" show-adjacent-months range
                                 @input="portfolioFilter.range.length == 2  ? portfolioDate = false : portfolioDate = true"
                  ></v-date-picker>
                </v-menu>
                <v-checkbox v-model="portfolioFilter.current" :label="$vuetify.lang.t('$vuetify.current')"
                            @change="loadPortfolio"></v-checkbox>
              </div>
              <div class="profile-objects">
                <div class="profile-objects-list">
                  <div class="list flex-row flex-wrap">
                    <ProfileObjectCard v-for="object in portfolio" :key="object.id"
                                       :photo="object.photo_path"
                                       :object_name="object.name" :object_id="object.id"
                                       :start_date="object.date_start" :end_date="object.date_end"
                                       :show_client="false"
                    ></ProfileObjectCard>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="tab_selected_1 === 7" class="profile-tabs__content-item">
            <CVs-component :currentProfile="currentProfile" :profile="profile"></CVs-component>
          </div>
        </div>
      </div>
    </v-form>

    <ConfirmModal v-model="confirm_document_modal" @confirm="deleteDocument">
      <span v-if="alertError">{{ alertMsg }}</span>
    </ConfirmModal>

    <v-dialog v-model="addDocumentModal">
      <div class="modal modal-big">
        <v-form ref="documentForm" @submit.prevent="">
          <v-text-field v-model="newDocument.name"
                        :label="$vuetify.lang.t('$vuetify.accounting.card.name')" outlined></v-text-field>
          <v-file-input v-if="newDocument.path" accept=".jpg, .png, .pdf, .doc, .docx" class="file-input" v-model="docs"
                        :placeholder="$vuetify.lang.t('$vuetify.changeDocument')"
                        prepend-icon="$document"></v-file-input>
          <v-file-input v-else accept=".jpg, .png, .pdf, .doc, .docx" class="file-input" v-model="docs"
                        :placeholder="$vuetify.lang.t('$vuetify.downloadDocument')"
                        prepend-icon="$document" :rules="[$rules.required]"></v-file-input>

          <v-progress-linear :class="{form__progress : form_loader}"
                             :active="form_loader"
                             indeterminate
                             rounded
                             height="6"
          ></v-progress-linear>

          <div v-if="alertError" class="error--text">{{ alertMsg }}</div>
          <div class="btn-group">
            <button class="btn btn-secondary" @click="cancelAddDocument">
              {{ $vuetify.lang.t('$vuetify.cancel') }}
            </button>
            <button class="btn btn-primary" @click="uploadDocumentFiles">
              {{ $vuetify.lang.t('$vuetify.save') }}
            </button>
          </div>
        </v-form>
      </div>
    </v-dialog>

    <CoolLightBox
        :items="lightboxItems"
        :index="index"
        @close="index = null; lightboxItems=[]">
    </CoolLightBox>

    <SpinnerLoader :overlay="loader"></SpinnerLoader>

    <MakeOfferToWorkerModal v-model="makeOfferModal" v-if="!profile"
                            :auth_user_id="currentProfile.auth_user_id.id"></MakeOfferToWorkerModal>

  </div>
</template>
<script>
import ProfileObjectCard from "../parts/ProfileObjectCard.vue";
import ConfirmModal from "@/components/confirmModal.vue";
import SpinnerLoader from "@/components/SpinnerLoader";
import {mapActions, mapGetters} from "vuex";
import CVsComponent from "@/components/profile/CVsComponent.vue";
import MakeOfferToWorkerModal from "@/components/MakeOfferToWorkerModal.vue";
import BaseCard from "@/views/parts/BaseCard.vue";
import BaseTable from "@/views/parts/BaseTable.vue";
import TextEditor from "@/views/TextEditor.vue";

export default {
  name: "profie-view",
  components: {
    TextEditor,
    BaseTable, BaseCard,
    MakeOfferToWorkerModal,
    ProfileObjectCard,
    ConfirmModal,
    SpinnerLoader,
    CVsComponent,
  },
  props: {
    id: String,
  },
  data: function () {
    return {
      type: "cards",
      width: screen.width,
      profile: false,
      options_date: {day: 'numeric', month: 'numeric', year: 'numeric'},
      objects_list_vis: {
        start: false,
        now: false,
        end: false
      },
      tab_selected: 1,
      tab_selected_1: 1,
      tmp: 5,
      currentProfile: {
        position: {},
        auth_user_id: {},
        address_fin: {
          index: "",
          country: "",
          city: "",
          street: "",
          house: "",
          entrance: "",
          flat: "",
        },
        phone: '',
        address_own: {
          index: "",
          country: "",
          city: "",
          street: "",
          house: "",
          entrance: "",
          flat: "",
        },
        other_positions: [],
        sign_path: null,
      },
      currentGroup: {},
      groups: [],
      clothes_items: {
        gloves: [5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12],
        clothes: ["42", "44", "46", "48", "50", "52", "54", "56"],
        boots: ["38", "39", "40", "41", "42", "43", "44", "45", "46", "47"],
      },
      clothes_menu: {shirt: false, pants: false, jacket: false, boots: false, gloves: false},
      valid: true,
      step: 1,

      positions: [],
      positionsSelect: [],
      selectedPosition: {},
      deletedPositions: [],

      cards: [],
      selectedCard: {},
      deletedCards: [],
      loadedCards: 0,

      objects: {},
      portfolio: [],
      portfolioFilter: {
        current: true,
        range: []
      },
      portfolioDate: false,

      documents: [],
      sort: '',
      selectSorts: [
        {name: this.$vuetify.lang.t('$vuetify.sorts.byName'), value: 'name'},
        {name: this.$vuetify.lang.t('$vuetify.sorts.byCreateDate'), value: 'create_date'},
      ],
      newDocument: {
        name: '',
        path: '',
        user_profile_id: this.id
      },
      docs: null,
      loadedFiles: 0,
      addDocumentModal: false,
      document_to_delete: 0,
      confirm_document_modal: false,
      headersDocuments: [
        {key: "name", name: 'documentName'},
        {key: "create_date", name: 'dateDownload'},
      ],
      showHeadersDocuments: {
        'name': true,
        'create_date': true,
      },

      options: {address: "yes"},
      photo: null,
      photoHtml: [],
      signature: null,
      menu1: false,
      menuCard: {
        1: false,
      },
      editing: false,
      other_language_check: false,

      tmp_skills: {},

      lightboxItems: [],
      index: null,
      organizations: [],

      loader: false,
      form_loader: false,
      alertMsg: '',
      alertError: false,

      makeOfferModal: false,
      company: JSON.parse(localStorage.getItem('organization')).id,
    };
  },
  watch: {
    loadedCards: function (val) {
      if (val === this.currentProfile.cards.length) {
        this.edit_profile()
      }
    },
    sort() {
      this.loadDocuments()
    },
    "portfolioFilter.range"() {
      if (this.portfolioFilter.range.length == 2) {
        this.loadPortfolio()
      }
    }
  },

  created: function () {
    if (!this.id) {
      this.loadData();
    } else {
      this.checkPermission('Работники').then(() => {
        this.loadData();
      })
    }

    if (this.$route.params.edit) {
      this.editing = true
      this.loadGroups()
    }
  },

  methods: {
    ...mapActions(['checkPermission']),

    openRespond() {
      this.makeOfferModal = true;
    },
    loadData: function () {
      if (this.id) {
        this.$axios({
          url: this.$hostname + "time-tracking/profiles/" + this.id,
          type: "GET",
          headers: {
            Authorization:
                "Token " +
                (localStorage.getItem("auth_token") ||
                    sessionStorage.getItem("auth_token")),
          },
        })
            .then((response) => {
              this.currentProfile = response.data.data.data;

              if (this.currentProfile.address_fin == null)
                this.currentProfile.address_fin = {
                  index: "",
                  country: "",
                  city: "",
                  street: "",
                  house: "",
                  entrance: "",
                  flat: "",
                };
              if (this.currentProfile.address_own == null)
                this.currentProfile.address_own = {
                  index: "",
                  country: "",
                  city: "",
                  street: "",
                  house: "",
                  entrance: "",
                  flat: "",
                };
              if (this.currentProfile.skills == null) {
                this.currentProfile.skills = {};
              }
              this.tmp_skills = structuredClone(this.currentProfile.skills);
              if (this.currentProfile.auto_category.length > 1) {
                this.currentProfile.auto_category = JSON.parse(this.currentProfile.auto_category)
              } else {
                let arr = []
                arr.push(this.currentProfile.auto_category)
                this.currentProfile.auto_category = arr
              }
              this.currentProfile.cards = this.currentProfile.cardsusers_set;
              this.organizations = this.currentProfile.organizations.map(org => org.id)
              this.loadedCards = 0
              this.loadCards();
              this.loadObjects();
              this.loadDocuments();
              this.loadPositions();
              this.loadSkills();
              this.loadPortfolio();
            })
            .catch((response) => {
              this.alertMsg = this.$catch(response);
              this.alertError = true;
            });
      } else {
        this.profile = true
        this.loadProfile()
      }
    },
    loadProfile() {
      this.$axios({
        url: this.$hostname + "time-tracking/user/full",
        method: "GET",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        this.currentProfile = response.data.data.data

        this.loadCards();
        this.loadObjects();
        this.loadDocuments();
        this.loadPositions();
        this.loadSkills();
        this.loadPortfolio();

        if (this.currentProfile.address_fin == null)
          this.currentProfile.address_fin = {
            index: "",
            country: "",
            city: "",
            street: "",
            house: "",
            entrance: "",
            flat: "",
          };
        if (this.currentProfile.address_own == null)
          this.currentProfile.address_own = {
            index: "",
            country: "",
            city: "",
            street: "",
            house: "",
            entrance: "",
            flat: "",
          };
        if (this.currentProfile.skills == null) {
          this.currentProfile.skills = {};
        }
        this.tmp_skills = structuredClone(this.currentProfile.skills);
        if (this.currentProfile.auto_category && this.currentProfile.auto_category.length > 1) {
          this.currentProfile.auto_category = JSON.parse(this.currentProfile.auto_category)
        } else {
          let arr = []
          arr.push(this.currentProfile.auto_category)
          this.currentProfile.auto_category = arr
        }
        this.currentProfile.cards = this.currentProfile.cardsusers_set;
        this.organizations = this.currentProfile.organizations.map(org => org.id)
        console.log(this.organizations.indexOf(this.company))
        this.loadedCards = 0
      }).catch((response) => {
        if (response.response.status === 404) {
          this.currentProfile = response.response.data.errors
          this.$router.push({name: "SignUpLayout", params: {id: this.currentProfile.id},})
        } else {
          this.alertMsg = this.$catch(response);
          this.alertError = true;
        }
      });
    },
    loadGroups() {
      if (this.permissions.admin) {
        this.$axios({
          url: this.$hostname + "time-tracking/groups",
          method: "GET",
          headers: {
            Authorization:
                "Token " +
                (localStorage.getItem("auth_token") ||
                    sessionStorage.getItem("auth_token")),
          },
        }).then((response) => {
          this.groups = response.data.data.groups
          this.groups.forEach(group => {
            group.name = JSON.parse(group.name)
          })
          this.groups.forEach(group => {
            if (this.currentProfile.auth_user_id.groups[0] === group.id) {
              this.currentGroup.name = group.name
              this.currentGroup.id = group.id
            }
          })
        }).catch((response) => {
          this.alertMsg = this.$catch(response)
          this.alertError = true
        })
      }
    },
    loadPositions() {
      this.$axios({
        url: this.$hostname + "time-tracking/profiles/positions",
        method: "GET",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
      })
          .then((response) => {
            this.positions = response.data.data.data;
          })
          .catch((error) => {
            this.alertMsg = this.$catch(error)
            alert(this.alertMsg);
          });
    },
    loadSkills() {
      this.$axios({
        url: this.$hostname + "time-tracking/profiles/skills",
        method: "GET",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
      })
          .then((response) => {
            this.positionsSelect = response.data.data.data;
          })
          .catch((error) => {
            this.alertMsg = "Непредвиденная ошибка";
            switch (error.response.status) {
              case 400:
                this.alertMsg = error.message;
                break;
              case 403:
                this.alertMsg = "Нет доступа";
                break;
              case 404:
                this.alertMsg = "Страница не найдена";
                break;
            }
            alert(this.alertMsg);
          });
    },
    loadCards() {
      this.$axios({
        url: this.$hostname + "time-tracking/profiles/cards",
        method: "GET",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
      })
          .then((response) => {
            this.cards = response.data.data.data
            this.currentProfile.cards.forEach(card => {
              let type = card.card
              this.cards = this.cards.filter((item) => {
                return (item.id !== type.id);
              })
            })
          })
          .catch((error) => {
            this.alertMsg = this.$catch(error)
          });
    },
    loadObjects() {
      let url = ""
      if (this.profile) {
        url = "time-tracking/profiles/objects/" + this.currentProfile.id
      } else {
        url = "time-tracking/profiles/objects/" + this.id
      }
      this.$axios({
        url: this.$hostname + url,
        method: "GET",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
        },
      })
          .then((response) => {
            this.objects.start = response.data.data.data.filter(function (item) {
              return (new Date(item.start_date) > new Date() && !item.objects_id.active)
            });

            this.objects.now = response.data.data.data.filter(function (item) {
              return (
                  new Date(item.start_date) <= new Date() && !item.objects_id.active
              );
            });

            this.objects.end = response.data.data.data.filter(function (item) {
              return (
                  item.objects_id.active
              );
            });
          })
          .catch((error) => {
            this.alertMsg = this.$catch(error);
          });
    },
    loadDocuments() {
      this.$axios({
        url: this.$hostname + "time-tracking/documents/worker/" + this.currentProfile.id,
        method: "GET",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        params: {
          sort: this.sort
        }
      })
          .then((response) => {
            this.documents = response.data.data.documents
            this.documents = this.documents.map(d => ({
              ...d,
              options: [
                {
                  value: new Date(d.create_date).toLocaleDateString(),
                  icon: '<svg width="24" height="24" focusable="false"\n' +
                      '                   aria-hidden="true" viewBox="0 0 24 24" data-testid="AssignmentOutlinedIcon"><path\n' +
                      '                d="M7 15h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"></path></svg>\n'
                },
              ]
            }))
            this.alertError = false
            this.docs = null
          })
          .catch((response) => {
            this.alertMsg = this.$catch(response);
            this.alertError = true;
          });
    },
    loadPortfolio() {
      let url = ""
      if (this.profile) {
        url = "time-tracking/profile/objects/" + this.currentProfile.id
      } else {
        url = "time-tracking/profile/objects/" + this.id
      }
      this.$axios({
        url: this.$hostname + url,
        method: "GET",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
        },
        params: {
          current: this.portfolioFilter.current,
          range: JSON.stringify(this.portfolioFilter.range),
        }
      }).then((response) => {
        this.portfolio = response.data.data.data
      }).catch((error) => {
        this.alertMsg = this.$catch(error);
      });
    },

    addUserDocument(file) {
      this.$axios({
        url: this.$hostname + "time-tracking/documents/workers",
        method: "POST",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          id: 0,
          name: file.name,
          path: file.path,
        },
      })
          .then((response) => {
            return response.data.name;
          })
          .catch((error) => {
            this.alertMsg = "Ошибка загрузки файла";
            switch (error.response.status) {
              case 400:
                this.alertMsg = error.message;
                break;
              case 403:
                this.alertMsg = "Доступ запрещен";
                break;
              case 404:
                this.alertMsg = "Страница не найдена";
                break;
            }
            alert(this.alertMsg);
          });
    },
    uploadFile(file) {
      this.$axios({
        url: this.$hostname + "time-tracking/images/upload/users",
        method: "POST",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          file: file,
        },
      })
          .then((response) => {
            this.currentProfile.photo_path = response.data.data;
            this.uploadSignFile()
          })
          .catch((error) => {
            this.alertMsg = this.$catch(error);
            alert(this.alertMsg);
          });
    },
    uploadSignFile() {
      if (this.signature) {
        this.$axios({
          url: this.$hostname + "time-tracking/get-sign",
          method: "POST",
          headers: {
            Authorization:
                "Token " +
                (localStorage.getItem("auth_token") ||
                    sessionStorage.getItem("auth_token")),
            "Content-Type": "multipart/form-data",
          },
          data: {
            file: this.signature,
          },
        })
            .then((response) => {
              this.currentProfile.sign_path = response.data.data;
              if (this.editing) {
                this.putProfile();
              }
            })
            .catch((error) => {
              this.alertMsg = this.$catch(error);
              alert(this.alertMsg);
            });
      } else {
        this.putProfile();
      }
    },

    uploadCardPhoto(card) {
      let promises = [];

      if (card.photo) {
        let promise1 = this.$axios({
          url: this.$hostname + "time-tracking/images/upload/users",
          method: "POST",
          headers: {
            Authorization:
                "Token " +
                (localStorage.getItem("auth_token") ||
                    sessionStorage.getItem("auth_token")),
            "Content-Type": "multipart/form-data",
          },
          data: {
            file: card.photo,
          },
        }).then((response) => {
          card.photo_path = response.data.data;
          card.photo = null;
          card.tmp_file = null;
        }).catch((error) => {
          this.alertMsg = "Ошибка загрузки файла";
          switch (error.response.status) {
            case 400:
              this.alertMsg = error.message;
              break;
            case 403:
              this.alertMsg = "Доступ запрещен";
              break;
            case 404:
              this.alertMsg = "Страница не найдена";
              break;
          }
          alert(this.alertMsg);
        });

        promises.push(promise1);
      }

      if (card.photo_2) {
        let promise2 = this.$axios({
          url: this.$hostname + "time-tracking/images/upload/users",
          method: "POST",
          headers: {
            Authorization:
                "Token " +
                (localStorage.getItem("auth_token") ||
                    sessionStorage.getItem("auth_token")),
            "Content-Type": "multipart/form-data",
          },
          data: {
            file: card.photo_2,
          },
        }).then((response) => {
          card.photo_path_2 = response.data.data;
          card.photo_2 = null;
          card.tmp_file_2 = null;
        }).catch(() => {
        });

        promises.push(promise2);
      }

      Promise.all(promises).then(() => {
        this.loadedCards++;
      });
    },
    addCard() {
      this.currentProfile.cards.push({
        id: 0,
        card: this.selectedCard.id,
        name: this.selectedCard.name,
        number: "",
        due_date: "",
        photo: null,
        show: true,
      });
      this.cards.splice(this.selectedCard, 1);
      this.selectedCard = -1;
    },
    deleteCard(i) {
      let item = this.currentProfile.cards[i];
      if (item.id !== 0)
        this.deletedCards.push(item)
      if (item.card.id)
        this.cards.push(item.card);
      else
        this.cards.push({id: item.card, name: item.name});
      this.currentProfile.cards.splice(i, 1);
    },

    addPosition() {
      this.currentProfile.other_positions.push({
        id: this.selectedPosition.id,
        name: this.selectedPosition.name,
      });
      this.positions.splice(this.selectedPosition, 1);
      this.selectedPosition = -1;
    },
    deletePosition(i) {
      let item = this.currentProfile.other_positions[i];
      if (item.id !== 0)
        this.deletedPositions.push(item)
      this.positions.push(item);
      this.currentProfile.other_positions.splice(i, 1);
    },

    switch_object_list(i) {
      this.objects_list_vis[i] = !this.objects_list_vis[i];
    },

    edit_cards() {
      if (this.$refs.form.validate()) {
        this.loader = true
        if (this.currentProfile.cards.length !== 0) {
          this.currentProfile.cards.forEach(card => {
            this.uploadCardPhoto(card)
          })
        } else {
          this.edit_profile()
        }
      } else {
        this.alertMsg = this.$vuetify.lang.t('$vuetify.fillForm')
      }
    },
    edit_group() {
      if (this.permissions.admin) {
        this.$axios({
          url: this.$hostname + "time-tracking/user-groups",
          method: "PUT",
          headers: {
            Authorization:
                "Token " +
                (localStorage.getItem("auth_token") ||
                    sessionStorage.getItem("auth_token")),
            "Content-Type": "multipart/form-data",
          },
          data: {
            auth_user_id: this.currentProfile.auth_user_id.id,
            group_id: this.currentGroup.id
          },
        }).then((response) => {
          this.currentGroup.name = response.data.data.data[0]
        }).catch((response) => {
          this.alertMsg = this.$catch(response)
          this.alertError = true
        })
      }
    },
    edit_profile() {
      if (this.permissions.admin && !this.profile)
        this.edit_group()
      this.currentProfile.skills = structuredClone(this.tmp_skills);
      if (this.photo != null)
        this.uploadFile(this.photo);
      else if (this.signature) {
        this.uploadSignFile();
      } else {
        this.putProfile();
      }
    },
    putProfile() {
      this.$axios({
        url: this.$hostname + "time-tracking/profiles",
        method: "PUT",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          id: this.currentProfile.id,
          auth_user_id: this.currentProfile.auth_user_id.id,
          name: this.currentProfile.name,
          lastname: this.currentProfile.lastname,
          citizenship: this.currentProfile.citizenship,
          birthdate: this.currentProfile.birthdate,
          social_code_own: this.currentProfile.social_code_own,
          social_code_fin: this.currentProfile.social_code_fin,
          address_own: JSON.stringify(this.currentProfile.address_own),
          address_fin: JSON.stringify(this.currentProfile.address_fin),
          phone: this.currentProfile.phone,
          phone_fin: this.currentProfile.phone_fin,
          bank_account: this.currentProfile.bank_account,
          tax_number: this.currentProfile.tax_number,
          auto: this.currentProfile.auto,
          auto_category: JSON.stringify(this.currentProfile.auto_category),
          tool: this.currentProfile.tool,
          english: this.currentProfile.english,
          estonian: this.currentProfile.estonian,
          finnish: this.currentProfile.finnish,
          russian: this.currentProfile.russian,
          other_language: this.currentProfile.other_language,
          position: this.currentProfile.position ? this.currentProfile.position.id : null,
          skills: JSON.stringify(this.currentProfile.skills),
          boots: this.currentProfile.boots,
          jacket: this.currentProfile.jacket,
          pants: this.currentProfile.pants,
          shirt: this.currentProfile.shirt,
          gloves: this.currentProfile.gloves,
          photo_path: this.currentProfile.photo_path,
          sign_path: this.currentProfile.sign_path,
          active: true,
          cards: JSON.stringify(this.currentProfile.cards),
          deleted: JSON.stringify(this.deletedCards),
          other_positions: JSON.stringify(this.currentProfile.other_positions),
          deleted_positions: JSON.stringify(this.deletedPositions),
          about_me: this.currentProfile.about_me
        },
      })
          .then(() => {
            this.editing = false;
            this.putUser();
            this.loadedCards = 0
            this.signature = null
            this.photo = null
            this.loader = false
          })
          .catch((error) => {
            this.alertMsg = this.$catch(error);
            alert(this.alertMsg);
          });
    },
    putUser() {
      this.$axios({
        url: this.$hostname + "time-tracking/user",
        method: "PUT",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          id: this.currentProfile.auth_user_id.id,
          username: this.currentProfile.auth_user_id.email.toLowerCase().replace(" ", ""),
          email: this.currentProfile.auth_user_id.email.toLowerCase().replace(" ", ""),
        },
      })
          .then(() => {
            this.loadData()
          })
          .catch((response) => {
            this.alertMsg = this.$catch(response);
            this.alertError = true;
          });
    },
    clickInput() {
      document.getElementById("photo").click();
    },
    clickSignInput() {
      document.getElementById("signature").click();
    },
    clickCardInput(i) {
      document.getElementById("photo" + i).click();
    },
    showFile(e, index) {
      var file = index.indexOf('-2') === -1 ? this.currentProfile.cards[index].photo : this.currentProfile.cards[index.replace('-2', '')].photo_2;
      if (file.type.match("image.*")) {
        var fr = new FileReader();
        fr.onload = (() => {
          return (e) => {
            if (index.indexOf('-2') !== -1) {
              this.currentProfile.cards[index.replace('-2', '')].tmp_file_2 = e.target.result;
            } else {
              this.currentProfile.cards[index].tmp_file = e.target.result;
            }
            this.currentProfile.cards = structuredClone(this.currentProfile.cards)
          };
        })(file);
        fr.readAsDataURL(file);
      }
    },

    downloadDocument(item) {
      let path = item.path
      let name = ''
      if (path.includes('_'))
        name = path.substr(path.lastIndexOf('/') + 1, path.lastIndexOf('_')) + path.substr(path.lastIndexOf('.'))
      else
        name = path.substr(path.lastIndexOf('/') + 1)
      this.$axios({
        url: this.$hostname + 'media/' + path,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', name);
        document.body.appendChild(fileLink);

        fileLink.click();
      })
    },
    addDocument() {
      this.$axios({
        url: this.$hostname + "time-tracking/documents/worker/" + this.currentProfile.id,
        method: "PUT",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: this.newDocument,
      })
          .then(() => {
            this.loadDocuments();
            this.newDocument = {
              name: '',
              path: '',
              user_profile_id: this.currentProfile.id
            }
            this.addDocumentModal = false
          })
          .catch((response) => {
            this.alertMsg = this.$catch(response);
            this.alertError = true;
          }).then(() => {
        this.form_loader = false
      })
    },
    deleteDocument() {
      this.$axios({
        url: this.$hostname + "time-tracking/documents/worker/" + this.currentProfile.id,
        method: "DELETE",
        headers: {
          Authorization:
              "Token " +
              (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          id: this.document_to_delete
        },
      })
          .then(() => {
            this.loadDocuments();
            this.confirm_document_modal = false
          })
          .catch((response) => {
            this.alertMsg = this.$catch(response);
            this.alertError = true;
          });
    },
    uploadDocumentFiles() {
      if (this.$refs.documentForm.validate()) {
        this.alertError = false
        if (this.docs == null) {
          if (!this.newDocument.path) {
            this.alertMsg = this.$vuetify.lang.t('$vuetify.addDocumentRule')
            this.alertError = true
          } else {
            this.addDocument()
          }
        } else {
          this.form_loader = true
          this.$axios({
            url: this.$hostname + "time-tracking/images/upload/" + "users",
            method: "POST",
            headers: {
              Authorization:
                  "Token " +
                  (localStorage.getItem("auth_token") ||
                      sessionStorage.getItem("auth_token")),
              "Content-Type": "multipart/form-data",
            },
            data: {
              file: this.docs,
            },
          })
              .then((response) => {
                this.newDocument.path = response.data.data
                this.newDocument.name = this.newDocument.name ? this.newDocument.name : this.docs.name
                this.addDocument()
              })
              .catch((error) => {
                alert("Ошибка загрузки файла: " + error.message);
              });
        }
      } else {
        this.alertMsg = "Заполните обязательные поля"
        this.alertError = true
      }
    },
    confirm_document_open(id) {
      this.confirm_document_modal = true;
      this.document_to_delete = id;
    },
    cancelAddDocument() {
      this.newDocument = {
        name: '',
        path: '',
        user_profile_id: this.currentProfile.id
      };
      this.addDocumentModal = false;
    },
    openFile(doc) {
      this.lightboxItems = [];
      if (new Date(doc.create_date).toDateString() >= new Date('29/05/2025').toDateString()) {
        this.lightboxItems.push(this.$hostname + 'time-tracking/preview/' + doc.path)
      } else if (['png', 'jpg', 'jpeg', 'JPG', 'PNG', 'JPEG'].includes(doc.path.substr(doc.path.lastIndexOf('.') + 1))) {
        this.lightboxItems.push(this.$media_url + doc.path);
      }
      this.index = 0
    },


    goLoginPage() {
      this.$router.push({name: "AuthLayout"});
    },
  },

  computed: {
    ...mapGetters(['permissions']),
  }

};
</script>
